export const FULL_COLLECTIONS = [
  {
    "id": "sapphire",
    "name": "Sapphire",
    "category": "faucets",
    "line": "Highflow Series",
    "image": "/assets/img/jsp-3613.jpg",
    "blurb": "Sculpted single-lever silhouettes engineered with HIGHFLOW cartridge precision.",
    "featured": {
      "model": "JSP-3621",
      "name": "Single Lever Basin Mixer",
      "price": 4960
    },
    "items": [
      {
        "model": "JSP-3621",
        "name": "Single Lever Basin Mixer",
        "price": 4960
      },
      {
        "model": "JSP-3622",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 6890,
        "img": "/assets/img/jsp-3622.jpg"
      },
      {
        "model": "JSP-3612",
        "name": "Pillar Cock",
        "price": 2480,
        "img": "/assets/cutouts/sapphire/jsp-3612.jpg"
      },
      {
        "model": "JSP-3613",
        "name": "Pillar Cock Extended Body",
        "price": 4510,
        "img": "/assets/cutouts/sapphire/jsp-3613.jpg"
      },
      {
        "model": "JSP-3630",
        "name": "Pillar Cock WM (exposed parts)",
        "price": 4205,
        "img": "/assets/cutouts/sapphire/jsp-3630.jpg"
      },
      {
        "model": "JSP-3601",
        "name": "Bib Cock with Flange",
        "price": 2180
      },
      {
        "model": "JSP-3603",
        "name": "Nozzle Bib Cock with Flange",
        "price": 2260
      },
      {
        "model": "JSP-3604",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 2920,
        "img": "/assets/cutouts/sapphire/jsp-3604.jpg"
      },
      {
        "model": "JSP-3609",
        "name": "2-in-1 Angle Cock with Wall Flange",
        "price": 2260,
        "img": "/assets/cutouts/sapphire/jsp-3609.jpg"
      },
      {
        "model": "JSP-3605",
        "name": "Angle Valve with Flange",
        "price": 1615
      },
      {
        "model": "JSP-3606",
        "name": "Concealed Stop Cock 15mm",
        "price": 995
      },
      {
        "model": "JSP-3607",
        "name": "Concealed Stop Cock 20mm",
        "price": 995,
        "img": "/assets/cutouts/sapphire/jsp-3607.jpg"
      },
      {
        "model": "JSP-3618",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 8320,
        "img": "/assets/cutouts/sapphire/jsp-3618.jpg"
      },
      {
        "model": "JSP-3619",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 8320,
        "img": "/assets/cutouts/sapphire/jsp-3619.jpg"
      },
      {
        "model": "JSP-3619 PR",
        "name": "Wall Mixer 2-in-1 Premium",
        "price": 9635,
        "img": "/assets/cutouts/sapphire/jsp-3619.jpg"
      },
      {
        "model": "JSP-3620",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 9215,
        "img": "/assets/cutouts/sapphire/jsp-3620.jpg"
      },
      {
        "model": "JSP-3615",
        "name": "Sink Cock",
        "price": 2725,
        "img": "/assets/cutouts/sapphire/jsp-3615.jpg"
      },
      {
        "model": "JSP-3616",
        "name": "Swan Neck",
        "price": 3225
      },
      {
        "model": "JSP-3617",
        "name": "Sink Mixer Q.T.",
        "price": 6920
      },
      {
        "model": "JSP-3610",
        "name": "Bath Tub Spout (Plain)",
        "price": 1790,
        "img": "/assets/cutouts/sapphire/jsp-3610.jpg"
      },
      {
        "model": "JSP-3611",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2515,
        "img": "/assets/cutouts/sapphire/jsp-3611.jpg"
      },
      {
        "model": "JSP-3626",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 4475,
        "img": "/assets/cutouts/sapphire/jsp-3626.jpg"
      },
      {
        "model": "JSP-3623",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 2005,
        "img": "/assets/cutouts/sapphire/jsp-3623.jpg"
      },
      {
        "model": "JSP-3623B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2325,
        "img": "/assets/cutouts/sapphire/jsp-3623b.jpg"
      },
      {
        "model": "JSP-3624",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2310,
        "img": "/assets/cutouts/sapphire/jsp-3624.jpg"
      },
      {
        "model": "JSP-3625",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2310,
        "img": "/assets/cutouts/sapphire/jsp-3625.jpg"
      },
      {
        "model": "JSP-3629",
        "name": "Single Lever 3-Way Body Diverter (exposed parts)",
        "price": 3470
      }
    ],
    "pages": [
      "/assets/pages_clean/p04.jpg",
      "/assets/pages_clean/p05.jpg"
    ]
  },
  {
    "id": "platinum",
    "name": "Platinum",
    "category": "faucets",
    "line": "Highflow Series",
    "image": "/assets/img/platinum.jpg",
    "blurb": "Weighty, architectural forms with a mirror-polished chrome presence.",
    "featured": {
      "model": "JPL-3812",
      "name": "Pillar Cock",
      "price": 3525
    },
    "items": [
      {
        "model": "JPL-3812",
        "name": "Pillar Cock",
        "price": 3525,
        "img": "/assets/cutouts/platinum/jpl-3812.jpg"
      },
      {
        "model": "JPL-3813",
        "name": "Pillar Cock Extended Body",
        "price": 4760,
        "img": "/assets/cutouts/platinum/jpl-3813.jpg"
      },
      {
        "model": "JPL-3801",
        "name": "Bib Cock with Flange",
        "price": 2570
      },
      {
        "model": "JPL-3803",
        "name": "Nozzle Bib Cock with Flange",
        "price": 2640,
        "img": "/assets/cutouts/platinum/jpl-3803.jpg"
      },
      {
        "model": "JPL-3804",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 3275,
        "img": "/assets/cutouts/platinum/jpl-3804.jpg"
      },
      {
        "model": "JPL-3805",
        "name": "Angle Valve with Flange",
        "price": 1870,
        "img": "/assets/cutouts/platinum/jpl-3805.jpg"
      },
      {
        "model": "JPL-3806",
        "name": "Concealed Stop Cock 15mm",
        "price": 1270
      },
      {
        "model": "JPL-3807",
        "name": "Concealed Stop Cock 20mm",
        "price": 1270,
        "img": "/assets/cutouts/platinum/jpl-3807.jpg"
      },
      {
        "model": "JPL-3818",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 9890,
        "img": "/assets/cutouts/platinum/jpl-3818.jpg"
      },
      {
        "model": "JPL-3819",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 9890,
        "img": "/assets/cutouts/platinum/jpl-3819.jpg"
      },
      {
        "model": "JPL-3819 (PR)",
        "name": "Wall Mixer 2-in-1 (Premium)",
        "price": 10930,
        "img": "/assets/cutouts/platinum/jpl-3819.jpg"
      },
      {
        "model": "JPL-3820",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 10630,
        "img": "/assets/cutouts/platinum/jpl-3820.jpg"
      },
      {
        "model": "JPL-3815",
        "name": "Sink Cock",
        "price": 3040,
        "img": "/assets/cutouts/platinum/jpl-3815.jpg"
      },
      {
        "model": "JPL-3816",
        "name": "Swan Neck",
        "price": 3735,
        "img": "/assets/cutouts/platinum/jpl-3816.jpg"
      },
      {
        "model": "JPL-3817",
        "name": "Sink Mixer Q.T.",
        "price": 7685,
        "img": "/assets/cutouts/platinum/jpl-3817.jpg"
      },
      {
        "model": "JPL-3810",
        "name": "Bath Tub Spout (Plain)",
        "price": 1985,
        "img": "/assets/cutouts/platinum/jpl-3810.jpg"
      },
      {
        "model": "JPL-3811",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2450,
        "img": "/assets/cutouts/platinum/jpl-3811.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p06.jpg",
      "/assets/pages_clean/p07.jpg"
    ]
  },
  {
    "id": "prada",
    "name": "Prada",
    "category": "faucets",
    "line": "Highflow Series",
    "image": "/assets/img/prada.jpg",
    "blurb": "A nod to classic style and substance \u2014 swan-neck curves, timeless stance.",
    "featured": {
      "model": "JPR-16017",
      "name": "Sink Mixer",
      "price": 6735
    },
    "items": [
      {
        "model": "F0134",
        "name": "Center Hole Basin Mixer with Braided Hoses",
        "price": null,
        "img": "/assets/cutouts/prada/f0134.jpg"
      },
      {
        "model": "JPR-16012",
        "name": "Pillar Tap",
        "price": 2465
      },
      {
        "model": "JPR-16013",
        "name": "Pillar Tap Extended",
        "price": 4360
      },
      {
        "model": "JPR-16001",
        "name": "Bib Tap",
        "price": 2015
      },
      {
        "model": "JPR-16002",
        "name": "Long Body Bib Tap",
        "price": 2305
      },
      {
        "model": "JPR-16003",
        "name": "Nozzle Bib Cock",
        "price": 2125
      },
      {
        "model": "JPR-16004",
        "name": "Two Way Bib Tap",
        "price": 3040
      },
      {
        "model": "JPR-16005",
        "name": "Angular Valve Quarter Turn Handle",
        "price": 1625
      },
      {
        "model": "JPR-16006",
        "name": "Concealed Stop Valve Exposed Part 15mm",
        "price": 930
      },
      {
        "model": "JPR-16007",
        "name": "Concealed Stop Valve Exposed Part 20mm",
        "price": 930
      },
      {
        "model": "JPR-16015",
        "name": "Sink Tap WM Swinging Spout",
        "price": 2590
      },
      {
        "model": "JPR-16016",
        "name": "Swan Neck",
        "price": 3130,
        "img": "/assets/cutouts/prada/jpr-16016.jpg"
      },
      {
        "model": "JPR-16017",
        "name": "Sink Mixer",
        "price": 6735
      },
      {
        "model": "JPR-16019",
        "name": "Wall Mixer 2-in-1",
        "price": 8860
      },
      {
        "model": "JPR-16020",
        "name": "Wall Mixer 3-in-1",
        "price": 9750
      }
    ],
    "pages": [
      "/assets/pages_clean/p08.jpg",
      "/assets/pages_clean/p09.jpg"
    ]
  },
  {
    "id": "pluto",
    "name": "Pluto",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/pluto.jpg",
    "blurb": "Cross-handle character meets a minimalist single-lever body.",
    "featured": {
      "model": "JPT-8721",
      "name": "Single Lever Basin Mixer",
      "price": 5515
    },
    "items": [
      {
        "model": "JPT-8721",
        "name": "Single Lever Basin Mixer",
        "price": 5515
      },
      {
        "model": "JPT-8722",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 8115,
        "img": "/assets/cutouts/pluto/jpt-8722.jpg"
      },
      {
        "model": "JPT-8714",
        "name": "Center Hole Basin Mixer with 18\" Braided Pipe",
        "price": 7580,
        "img": "/assets/cutouts/pluto/jpt-8714.jpg"
      },
      {
        "model": "JPT-8712",
        "name": "Pillar Cock",
        "price": 2840,
        "img": "/assets/cutouts/pluto/jpt-8712.jpg"
      },
      {
        "model": "JPT-8713",
        "name": "Pillar Cock Extended Body",
        "price": 4050,
        "img": "/assets/cutouts/pluto/jpt-8713.jpg"
      },
      {
        "model": "JPT-8730",
        "name": "Pillar Cock WM (exposed part)",
        "price": 4160,
        "img": "/assets/cutouts/pluto/jpt-8730.jpg"
      },
      {
        "model": "JPT-8701",
        "name": "Bib Cock with Flange",
        "price": 1995
      },
      {
        "model": "JPT-8703",
        "name": "Bib Cock Nozzle",
        "price": 2075,
        "img": "/assets/cutouts/pluto/jpt-8703.jpg"
      },
      {
        "model": "JPT-8704",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 2295
      },
      {
        "model": "JPT-8709",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 2540,
        "img": "/assets/cutouts/pluto/jpt-8709.jpg"
      },
      {
        "model": "JPT-8705",
        "name": "Angle Valve with Flange",
        "price": 1360
      },
      {
        "model": "JPT-8706",
        "name": "Concealed Stop Cock 15mm",
        "price": 1160,
        "img": "/assets/cutouts/pluto/jpt-8706.jpg"
      },
      {
        "model": "JPT-8707",
        "name": "Concealed Stop Cock 20mm",
        "price": 1160,
        "img": "/assets/cutouts/pluto/jpt-8707.jpg"
      },
      {
        "model": "JPT-8718",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 8835,
        "img": "/assets/cutouts/pluto/jpt-8718.jpg"
      },
      {
        "model": "JPT-8719",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 8835,
        "img": "/assets/cutouts/pluto/jpt-8719.jpg"
      },
      {
        "model": "JPT-8720",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 9650,
        "img": "/assets/cutouts/pluto/jpt-8720.jpg"
      },
      {
        "model": "JPT-8715",
        "name": "Sink Cock",
        "price": 3490,
        "img": "/assets/cutouts/pluto/jpt-8715.jpg"
      },
      {
        "model": "JPT-8716",
        "name": "Swan Neck",
        "price": 4270,
        "img": "/assets/cutouts/pluto/jpt-8716.jpg"
      },
      {
        "model": "JPT-8717",
        "name": "Sink Mixer Q.T.",
        "price": 7625,
        "img": "/assets/cutouts/pluto/jpt-8717.jpg"
      },
      {
        "model": "JPT-8710",
        "name": "Bath Tub Spout (Plain)",
        "price": 1580
      },
      {
        "model": "JPT-8711",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2585
      },
      {
        "model": "JPT-8726",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 4940
      },
      {
        "model": "JPT-8723",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 3210,
        "img": "/assets/cutouts/pluto/jpt-8723.jpg"
      },
      {
        "model": "JPT-8723B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 3560
      },
      {
        "model": "JPT-8724",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 3595,
        "img": "/assets/cutouts/pluto/jpt-8724.jpg"
      },
      {
        "model": "JPT-8725",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 3595,
        "img": "/assets/cutouts/pluto/jpt-8725.jpg"
      },
      {
        "model": "JPT-8729",
        "name": "Single Lever 3-Way Diverter (exposed part)",
        "price": 4140
      }
    ],
    "pages": [
      "/assets/pages_clean/p10.jpg",
      "/assets/pages_clean/p11.jpg"
    ]
  },
  {
    "id": "aster_premium",
    "name": "Aster Premium",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/aster_premium.jpg",
    "blurb": "The elevated Aster \u2014 refined detailing, premium presence.",
    "featured": {
      "model": "JAP-17021",
      "name": "Single Lever Basin Mixer",
      "price": 5510
    },
    "items": [
      {
        "model": "JAP-17021",
        "name": "Single Lever Basin Mixer",
        "price": 5510
      },
      {
        "model": "JAP-17022",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 7210,
        "img": "/assets/cutouts/aster_premium/jap-17022.jpg"
      },
      {
        "model": "JAP-17012",
        "name": "Pillar Cock",
        "price": 2730
      },
      {
        "model": "JAP-17013",
        "name": "Pillar Cock Extended Body",
        "price": 4460,
        "img": "/assets/cutouts/aster_premium/jap-17013.jpg"
      },
      {
        "model": "JAP-17030",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3845
      },
      {
        "model": "JAP-17001",
        "name": "Bib Cock with Flange",
        "price": 2315
      },
      {
        "model": "JAP-17003",
        "name": "Nozzle Bib Cock with Flange",
        "price": 2395
      },
      {
        "model": "JAP-17004",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1720
      },
      {
        "model": "JAP-17009",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 2010,
        "img": "/assets/cutouts/aster_premium/jap-17009.jpg"
      },
      {
        "model": "JAP-17005",
        "name": "Angle Valve with Flange",
        "price": 805,
        "img": "/assets/cutouts/aster_premium/jap-17005.jpg"
      },
      {
        "model": "JAP-17006",
        "name": "Concealed Stop Cock 15mm",
        "price": 715
      },
      {
        "model": "JAP-17007",
        "name": "Concealed Stop Cock 20mm",
        "price": 715,
        "img": "/assets/cutouts/aster_premium/jap-17007.jpg"
      },
      {
        "model": "JAP-17018",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 8160
      },
      {
        "model": "JAP-17019",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 8160,
        "img": "/assets/cutouts/aster_premium/jap-17019.jpg"
      },
      {
        "model": "JAP-17020",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 8810,
        "img": "/assets/cutouts/aster_premium/jap-17020.jpg"
      },
      {
        "model": "JAP-17015",
        "name": "Sink Cock",
        "price": 2505
      },
      {
        "model": "JAP-17016",
        "name": "Swan Neck",
        "price": 2590
      },
      {
        "model": "JAP-17017",
        "name": "Sink Mixer Q.T.",
        "price": 5295,
        "img": "/assets/cutouts/aster_premium/jap-17017.jpg"
      },
      {
        "model": "JAP-17010",
        "name": "Bath Tub Spout (Plain)",
        "price": 1515
      },
      {
        "model": "JAP-17011",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2345
      },
      {
        "model": "JAP-17026",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 4320,
        "img": "/assets/cutouts/aster_premium/jap-17026.jpg"
      },
      {
        "model": "JAP-17023",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 2015
      },
      {
        "model": "JAP-17023B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2440
      },
      {
        "model": "JAP-17024",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2435
      },
      {
        "model": "JAP-17025",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2435,
        "img": "/assets/cutouts/aster_premium/jap-17025.jpg"
      },
      {
        "model": "JAP-17029",
        "name": "Single Lever 3-Way Diverter (exposed parts)",
        "price": 3210,
        "img": "/assets/cutouts/aster_premium/jap-17029.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p12.jpg",
      "/assets/pages_clean/p13.jpg"
    ]
  },
  {
    "id": "amaze",
    "name": "Amaze",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/amaze.jpg",
    "blurb": "Everyday elegance with smooth, low-maintenance operation.",
    "featured": {
      "model": "JAM-14021",
      "name": "Single Lever Basin Mixer",
      "price": 5110
    },
    "items": [
      {
        "model": "JAM-14021",
        "name": "Single Lever Basin Mixer",
        "price": 5110,
        "img": "/assets/cutouts/amaze/jam-14021.jpg"
      },
      {
        "model": "JAM-14022",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 7025
      },
      {
        "model": "JAM-14012",
        "name": "Pillar Cock",
        "price": 1820,
        "img": "/assets/cutouts/amaze/jam-14012.jpg"
      },
      {
        "model": "JAM-14012A",
        "name": "Pillar Tap Premium",
        "price": 2280,
        "img": "/assets/cutouts/amaze/jam-14012a.jpg"
      },
      {
        "model": "JAM-14013",
        "name": "Pillar Cock Extended Body",
        "price": 3335,
        "img": "/assets/cutouts/amaze/jam-14013.jpg"
      },
      {
        "model": "JAM-14001",
        "name": "Bib Cock with Flange",
        "price": 1665
      },
      {
        "model": "JAM-14002",
        "name": "Long Body Bib Cock with Flange",
        "price": 1695,
        "img": "/assets/cutouts/amaze/jam-14002.jpg"
      },
      {
        "model": "JAM-14003",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1720,
        "img": "/assets/cutouts/amaze/jam-14003.jpg"
      },
      {
        "model": "JAM-14004",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 2455,
        "img": "/assets/cutouts/amaze/jam-14004.jpg"
      },
      {
        "model": "JAM-14009",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 2385,
        "img": "/assets/cutouts/amaze/jam-14009.jpg"
      },
      {
        "model": "JAM-14005",
        "name": "Angle Valve with Flange",
        "price": 1265,
        "img": "/assets/cutouts/amaze/jam-14005.jpg"
      },
      {
        "model": "JAM-14006",
        "name": "Concealed Stop Cock 15mm",
        "price": 1265,
        "img": "/assets/cutouts/amaze/jam-14006.jpg"
      },
      {
        "model": "JAM-14007",
        "name": "Concealed Stop Cock 20mm",
        "price": 1265,
        "img": "/assets/cutouts/amaze/jam-14007.jpg"
      },
      {
        "model": "JAM-14018",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 7525
      },
      {
        "model": "JAM-14019",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 7630,
        "img": "/assets/cutouts/amaze/jam-14019.jpg"
      },
      {
        "model": "JAM-14020",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 8405,
        "img": "/assets/cutouts/amaze/jam-14020.jpg"
      },
      {
        "model": "JAM-14015",
        "name": "Sink Cock",
        "price": 2520,
        "img": "/assets/cutouts/amaze/jam-14015.jpg"
      },
      {
        "model": "JAM-14015 BS",
        "name": "Sink Cock with J-Spout Brass",
        "price": 2395,
        "img": "/assets/cutouts/amaze/jam-14015.jpg"
      },
      {
        "model": "JAM-14015 CS",
        "name": "Sink Cock with Casted Spout",
        "price": 2820,
        "img": "/assets/cutouts/amaze/jam-14015.jpg"
      },
      {
        "model": "JAM-14016",
        "name": "Swan Neck",
        "price": 2815
      },
      {
        "model": "JAM-14017",
        "name": "Sink Mixer Q.T.",
        "price": 5675
      },
      {
        "model": "JAM-14010",
        "name": "Bath Tub Spout (Plain)",
        "price": 1850,
        "img": "/assets/cutouts/amaze/jam-14010.jpg"
      },
      {
        "model": "JAM-14011",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2540,
        "img": "/assets/cutouts/amaze/jam-14011.jpg"
      },
      {
        "model": "JAM-14026",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 3635,
        "img": "/assets/cutouts/amaze/jam-14026.jpg"
      },
      {
        "model": "JAM-14034",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts, large)",
        "price": 3910,
        "img": "/assets/cutouts/amaze/jam-14034.jpg"
      },
      {
        "model": "JAM-14023",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 2505
      },
      {
        "model": "JAM-14023B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2815,
        "img": "/assets/cutouts/amaze/jam-14023b.jpg"
      },
      {
        "model": "JAM-14024",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2825,
        "img": "/assets/cutouts/amaze/jam-14024.jpg"
      },
      {
        "model": "JAM-14025",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2825,
        "img": "/assets/cutouts/amaze/jam-14025.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p14.jpg",
      "/assets/pages_clean/p15.jpg"
    ]
  },
  {
    "id": "pearl",
    "name": "Pearl",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/pearl.jpg",
    "blurb": "Soft contours with a luminous chrome finish.",
    "featured": {
      "model": "JPE-6321",
      "name": "Single Lever Basin Mixer",
      "price": 6345
    },
    "items": [
      {
        "model": "JPE-6321",
        "name": "Single Lever Basin Mixer",
        "price": 6345
      },
      {
        "model": "JPE-6322",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 12440,
        "img": "/assets/cutouts/pearl/jpe-6322.jpg"
      },
      {
        "model": "JPE-6312",
        "name": "Pillar Cock",
        "price": 1850
      },
      {
        "model": "JPE-6312A",
        "name": "Pillar Cock Premium",
        "price": 2120,
        "img": "/assets/cutouts/pearl/jpe-6312a.jpg"
      },
      {
        "model": "JPE-6313",
        "name": "Pillar Cock Extended Body",
        "price": 5110,
        "img": "/assets/cutouts/pearl/jpe-6313.jpg"
      },
      {
        "model": "JPE-6330",
        "name": "Pillar Cock WM (exposed part)",
        "price": 4040,
        "img": "/assets/cutouts/pearl/jpe-6330.jpg"
      },
      {
        "model": "JPE-6301",
        "name": "Bib Cock with Flange",
        "price": 1370
      },
      {
        "model": "JPE-6302",
        "name": "Long Body Bib Cock with Flange",
        "price": 1485
      },
      {
        "model": "JPE-6303",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1430
      },
      {
        "model": "JPE-6304",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 2370
      },
      {
        "model": "JPE-6309",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1895,
        "img": "/assets/cutouts/pearl/jpe-6309.jpg"
      },
      {
        "model": "JPE-6305",
        "name": "Angle Valve with Flange",
        "price": 1170,
        "img": "/assets/cutouts/pearl/jpe-6305.jpg"
      },
      {
        "model": "JPE-6306",
        "name": "Concealed Stop Cock 15mm",
        "price": 880,
        "img": "/assets/cutouts/pearl/jpe-6306.jpg"
      },
      {
        "model": "JPE-6307",
        "name": "Concealed Stop Cock 20mm",
        "price": 880,
        "img": "/assets/cutouts/pearl/jpe-6307.jpg"
      },
      {
        "model": "JPE-6318",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 6930,
        "img": "/assets/cutouts/pearl/jpe-6318.jpg"
      },
      {
        "model": "JPE-6319",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 6930,
        "img": "/assets/cutouts/pearl/jpe-6319.jpg"
      },
      {
        "model": "JPE-6320",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 7795,
        "img": "/assets/cutouts/pearl/jpe-6320.jpg"
      },
      {
        "model": "JPE-6315A",
        "name": "Sink Cock with Brass Spout",
        "price": 2425,
        "img": "/assets/cutouts/pearl/jpe-6315a.jpg"
      },
      {
        "model": "JPE-6315CS",
        "name": "Sink Cock with Brass Spout (Casted)",
        "price": 2990
      },
      {
        "model": "JPE-6315B",
        "name": "Sink Cock with SS 202 Flat Spout",
        "price": 2310
      },
      {
        "model": "JPE-6315C",
        "name": "Sink Cock with SS 304 Flat Spout",
        "price": 2620
      },
      {
        "model": "JPE-6316A",
        "name": "Swan Neck",
        "price": 2625,
        "img": "/assets/cutouts/pearl/jpe-6316a.jpg"
      },
      {
        "model": "JPE-6316B",
        "name": "Swan Neck with SS 202 Flat Spout",
        "price": 2515
      },
      {
        "model": "JPE-6316C",
        "name": "Swan Neck with SS 304 Flat Spout",
        "price": 2830,
        "img": "/assets/cutouts/pearl/jpe-6316c.jpg"
      },
      {
        "model": "JPE-6317A",
        "name": "Sink Mixer Q.T.",
        "price": 5360
      },
      {
        "model": "JPE-6317B",
        "name": "Sink Mixer Q.T. with SS 202 Flat Spout",
        "price": 5250,
        "img": "/assets/cutouts/pearl/jpe-6317b.jpg"
      },
      {
        "model": "JPE-6317C",
        "name": "Sink Mixer Q.T. with SS 304 Flat Spout",
        "price": 5640
      },
      {
        "model": "JPE-6310",
        "name": "Bath Tub Spout (Plain)",
        "price": 1625,
        "img": "/assets/cutouts/pearl/jpe-6310.jpg"
      },
      {
        "model": "JPE-6311",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2465,
        "img": "/assets/cutouts/pearl/jpe-6311.jpg"
      },
      {
        "model": "JPE-6326",
        "name": "Wall Mounted SL Concealed Basin Mixer (exposed part)",
        "price": 4700
      },
      {
        "model": "JPE-6323",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 2395,
        "img": "/assets/cutouts/pearl/jpe-6323.jpg"
      },
      {
        "model": "JPE-6323B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2895
      },
      {
        "model": "JPE-6324",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2885
      },
      {
        "model": "JPE-6325",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2885
      },
      {
        "model": "JPE-6329",
        "name": "Single Lever 3-Way Diverter (exposed part)",
        "price": 3540
      }
    ],
    "pages": [
      "/assets/pages_clean/p16.jpg",
      "/assets/pages_clean/p17.jpg"
    ]
  },
  {
    "id": "aster",
    "name": "Aster",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/aster.jpg",
    "blurb": "The workhorse collection \u2014 complete fittings for the modern bath.",
    "featured": {
      "model": "JAS-2421",
      "name": "Single Lever Basin Mixer",
      "price": 4880
    },
    "items": [
      {
        "model": "JAS-2421",
        "name": "Single Lever Basin Mixer",
        "price": 4880
      },
      {
        "model": "JAS-2422",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 7035,
        "img": "/assets/cutouts/aster/jas-2422.jpg"
      },
      {
        "model": "JAS-2414",
        "name": "Center Hole Basin Mixer with 18\" Braided Pipe",
        "price": 4015,
        "img": "/assets/cutouts/aster/jas-2414.jpg"
      },
      {
        "model": "JAS-2412",
        "name": "Pillar Cock",
        "price": 1380,
        "img": "/assets/cutouts/aster/jas-2412.jpg"
      },
      {
        "model": "JAS-2412A",
        "name": "Pillar Cock Premium",
        "price": 2120
      },
      {
        "model": "JAS-2431",
        "name": "Pillar Cock 7\"",
        "price": 3640,
        "img": "/assets/cutouts/aster/jas-2431.jpg"
      },
      {
        "model": "JAS-2432",
        "name": "Pillar Cock 9\"",
        "price": 3820,
        "img": "/assets/cutouts/aster/jas-2432.jpg"
      },
      {
        "model": "JAS-2433",
        "name": "Pillar Cock Extended Body",
        "price": 4165,
        "img": "/assets/cutouts/aster/jas-2433.jpg"
      },
      {
        "model": "JAS-2430",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3835,
        "img": "/assets/cutouts/aster/jas-2430.jpg"
      },
      {
        "model": "JAS-2401",
        "name": "Bib Cock with Flange",
        "price": 1150
      },
      {
        "model": "JAS-2402",
        "name": "Long Body Bib Cock with Flange",
        "price": 1320
      },
      {
        "model": "JAS-2403",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1240,
        "img": "/assets/cutouts/aster/jas-2403.jpg"
      },
      {
        "model": "JAS-2404",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1825,
        "img": "/assets/cutouts/aster/jas-2404.jpg"
      },
      {
        "model": "JAS-2404A",
        "name": "Bib Cock 2-in-1 Double Handle with Flange",
        "price": 2025,
        "img": "/assets/cutouts/aster/jas-2404a.jpg"
      },
      {
        "model": "JAS-2409",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1980,
        "img": "/assets/cutouts/aster/jas-2409.jpg"
      },
      {
        "model": "JAS-2405",
        "name": "Angle Valve with Flange",
        "price": 805
      },
      {
        "model": "JAS-2406",
        "name": "Concealed Stop Cock 15mm",
        "price": 715
      },
      {
        "model": "JAS-2407",
        "name": "Concealed Stop Cock 20mm",
        "price": 715
      },
      {
        "model": "JAS-2418",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 7020,
        "img": "/assets/cutouts/aster/jas-2418.jpg"
      },
      {
        "model": "JAS-2419",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 7065,
        "img": "/assets/cutouts/aster/jas-2419.jpg"
      },
      {
        "model": "JAS-2420",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 7715,
        "img": "/assets/cutouts/aster/jas-2420.jpg"
      },
      {
        "model": "JAS-2415",
        "name": "Sink Cock",
        "price": 2160,
        "img": "/assets/cutouts/aster/jas-2415.jpg"
      },
      {
        "model": "JAS-2415A",
        "name": "Sink Cock Multi Flow Silicon Spout",
        "price": 2470
      },
      {
        "model": "JAS-2415B",
        "name": "Sink Cock Single Flow Silicon Spout",
        "price": 2080,
        "img": "/assets/cutouts/aster/jas-2415b.jpg"
      },
      {
        "model": "JAS-2415PR",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2840
      },
      {
        "model": "JAS-2416",
        "name": "Swan Neck",
        "price": 2480,
        "img": "/assets/cutouts/aster/jas-2416.jpg"
      },
      {
        "model": "JAS-2416A",
        "name": "Swan Neck Multi Flow Silicon Spout",
        "price": 2790,
        "img": "/assets/cutouts/aster/jas-2416a.jpg"
      },
      {
        "model": "JAS-2416B",
        "name": "Swan Neck Single Flow Silicon Spout",
        "price": 2410,
        "img": "/assets/cutouts/aster/jas-2416b.jpg"
      },
      {
        "model": "JAS-2416PR",
        "name": "Swan Neck S. Flow Silicon Spout (Premium)",
        "price": 3170
      },
      {
        "model": "JAS-2417",
        "name": "Sink Mixer Q.T.",
        "price": 5150,
        "img": "/assets/cutouts/aster/jas-2417.jpg"
      },
      {
        "model": "JAS-2417A",
        "name": "Sink Mixer Multi Flow Silicon Spout",
        "price": 5390,
        "img": "/assets/cutouts/aster/jas-2417a.jpg"
      },
      {
        "model": "JAS-2417B",
        "name": "Sink Mixer Single Flow Silicon Spout",
        "price": 5080,
        "img": "/assets/cutouts/aster/jas-2417b.jpg"
      },
      {
        "model": "JAS-2417PR",
        "name": "Sink Mixer S. Flow Silicon Spout (Premium)",
        "price": 5880
      },
      {
        "model": "JAS-2410",
        "name": "Bath Tub Spout (Plain)",
        "price": 1485,
        "img": "/assets/cutouts/aster/jas-2410.jpg"
      },
      {
        "model": "JAS-2411",
        "name": "Bath Spout with Tip Ton for Telephonic Shower",
        "price": 2390
      },
      {
        "model": "JAS-2428",
        "name": "Table Mounted Single Lever Sink Mixer",
        "price": 8190,
        "img": "/assets/cutouts/aster/jas-2428.jpg"
      },
      {
        "model": "JAS-2426",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 4270,
        "img": "/assets/cutouts/aster/jas-2426.jpg"
      },
      {
        "model": "JAS-2423",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 1805,
        "img": "/assets/cutouts/aster/jas-2423.jpg"
      },
      {
        "model": "JAS-2423B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2240,
        "img": "/assets/cutouts/aster/jas-2423b.jpg"
      },
      {
        "model": "JAS-2424",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2230,
        "img": "/assets/cutouts/aster/jas-2424.jpg"
      },
      {
        "model": "JAS-2425",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2230,
        "img": "/assets/cutouts/aster/jas-2425.jpg"
      },
      {
        "model": "JAS-2429",
        "name": "Single Lever 3-Way Diverter (exposed parts)",
        "price": 3490,
        "img": "/assets/cutouts/aster/jas-2429.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p18.jpg",
      "/assets/pages_clean/p19.jpg",
      "/assets/pages_clean/p20.jpg",
      "/assets/pages_clean/p21.jpg"
    ]
  },
  {
    "id": "freesia",
    "name": "Freesia",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/freesia.jpg",
    "blurb": "Premium silicon-spout sink mixers and concealed diverter systems.",
    "featured": {
      "model": "JFR-2621",
      "name": "Single Lever Basin Mixer",
      "price": 5245
    },
    "items": [
      {
        "model": "JFR-2621",
        "name": "Single Lever Basin Mixer",
        "price": 5245
      },
      {
        "model": "JFR-2622",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 6870,
        "img": "/assets/cutouts/freesia/jfr-2622.jpg"
      },
      {
        "model": "JFR-2612",
        "name": "Pillar Cock",
        "price": 1585,
        "img": "/assets/cutouts/freesia/jfr-2612.jpg"
      },
      {
        "model": "JFR-2612A",
        "name": "Pillar Cock Premium",
        "price": 2050
      },
      {
        "model": "JFR-2633",
        "name": "Pillar Cock 6\"",
        "price": 2540
      },
      {
        "model": "JFR-2631",
        "name": "Pillar Cock 7\"",
        "price": 3090
      },
      {
        "model": "JFR-2632",
        "name": "Pillar Cock 9\"",
        "price": 3540
      },
      {
        "model": "JFR-2630",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3750
      },
      {
        "model": "JFR-2601",
        "name": "Bib Cock with Flange",
        "price": 1260
      },
      {
        "model": "JFR-2602",
        "name": "Long Body Bib Cock with Flange",
        "price": 1305,
        "img": "/assets/cutouts/freesia/jfr-2602.jpg"
      },
      {
        "model": "JFR-2603",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1320,
        "img": "/assets/cutouts/freesia/jfr-2603.jpg"
      },
      {
        "model": "JFR-2604",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1870,
        "img": "/assets/cutouts/freesia/jfr-2604.jpg"
      },
      {
        "model": "JFR-2604A",
        "name": "Bib Cock 2-in-1 Double Handle with Flange",
        "price": 2065,
        "img": "/assets/cutouts/freesia/jfr-2604a.jpg"
      },
      {
        "model": "JFR-2609",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 2065,
        "img": "/assets/cutouts/freesia/jfr-2609.jpg"
      },
      {
        "model": "JFR-2605",
        "name": "Angle Valve with Flange",
        "price": 870,
        "img": "/assets/cutouts/freesia/jfr-2605.jpg"
      },
      {
        "model": "JFR-2606",
        "name": "Concealed Stop Cock 15mm",
        "price": 770,
        "img": "/assets/cutouts/freesia/jfr-2606.jpg"
      },
      {
        "model": "JFR-2607",
        "name": "Concealed Stop Cock 20mm",
        "price": 770,
        "img": "/assets/cutouts/freesia/jfr-2607.jpg"
      },
      {
        "model": "JFR-2618",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 6790,
        "img": "/assets/cutouts/freesia/jfr2618.jpg"
      },
      {
        "model": "JFR-2619",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 6785,
        "img": "/assets/cutouts/freesia/jfr-2619.jpg"
      },
      {
        "model": "JFR-2620",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 7410
      },
      {
        "model": "JFR-2615",
        "name": "Sink Cock",
        "price": 2210,
        "img": "/assets/cutouts/freesia/jfr-2615.jpg"
      },
      {
        "model": "JFR-2615A",
        "name": "Sink Cock Multi Flow Silicon Spout",
        "price": 2410,
        "img": "/assets/cutouts/freesia/jfr-2615a.jpg"
      },
      {
        "model": "JFR-2615B",
        "name": "Sink Cock Single Flow Silicon Spout",
        "price": 2190,
        "img": "/assets/cutouts/freesia/jfr-2615b.jpg"
      },
      {
        "model": "JFR-2615 (PR)",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2990,
        "img": "/assets/cutouts/freesia/jfr-2615.jpg"
      },
      {
        "model": "JFR-2616",
        "name": "Swan Neck",
        "price": 2550,
        "img": "/assets/cutouts/freesia/jfr-2616.jpg"
      },
      {
        "model": "JFR-2616A",
        "name": "Swan Neck Multi Flow Silicon Spout",
        "price": 2740,
        "img": "/assets/cutouts/freesia/jfr-2616a.jpg"
      },
      {
        "model": "JFR-2616B",
        "name": "Swan Neck Single Flow Silicon Spout",
        "price": 2510,
        "img": "/assets/cutouts/freesia/jfr-2616b.jpg"
      },
      {
        "model": "JFR-2616 (PR)",
        "name": "Swan Neck S. Flow Silicon Spout (Premium)",
        "price": 3320,
        "img": "/assets/cutouts/freesia/jfr-2616.jpg"
      },
      {
        "model": "JFR-2617",
        "name": "Sink Mixer Q.T.",
        "price": 5030,
        "img": "/assets/cutouts/freesia/jfr-2617.jpg"
      },
      {
        "model": "JFR-2617A",
        "name": "Sink Mixer Multi Flow Silicon Spout",
        "price": 5450,
        "img": "/assets/cutouts/freesia/jfr-2617a.jpg"
      },
      {
        "model": "JFR-2617B",
        "name": "Sink Mixer Single Flow Silicon Spout",
        "price": 5150,
        "img": "/assets/cutouts/freesia/jfr-2617b.jpg"
      },
      {
        "model": "JFR-2617 (PR)",
        "name": "Sink Mixer S. Flow Silicon Spout (Premium)",
        "price": 5960,
        "img": "/assets/cutouts/freesia/jfr-2617.jpg"
      },
      {
        "model": "JFR-2610",
        "name": "Bath Tub Spout (Plain)",
        "price": 1505
      },
      {
        "model": "JFR-2611",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2245
      },
      {
        "model": "JFR-2628",
        "name": "Table Mounted Single Lever Sink Mixer",
        "price": 8210,
        "img": "/assets/cutouts/freesia/jfr-2628.jpg"
      },
      {
        "model": "JFR-2626",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 3995,
        "img": "/assets/cutouts/freesia/jfr-2626.jpg"
      },
      {
        "model": "JFR-2623",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 1895,
        "img": "/assets/cutouts/freesia/jfr-2623.jpg"
      },
      {
        "model": "JFR-2623B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2190
      },
      {
        "model": "JFR-2624",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2180
      },
      {
        "model": "JFR-2625",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2180,
        "img": "/assets/cutouts/freesia/jfr-2625.jpg"
      },
      {
        "model": "JFR-2629",
        "name": "Single Lever Concealed 3-Way Diverter (exposed parts)",
        "price": 3210,
        "img": "/assets/cutouts/freesia/jfr-2629.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p22.jpg",
      "/assets/pages_clean/p23.jpg",
      "/assets/pages_clean/p24.jpg",
      "/assets/pages_clean/p25.jpg"
    ]
  },
  {
    "id": "iris",
    "name": "Iris",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/iris.jpg",
    "blurb": "Contemporary chrome lines tuned for perfect water flow.",
    "featured": {
      "model": "JIR-2321",
      "name": "Single Lever Basin Mixer",
      "price": 5165
    },
    "items": [
      {
        "model": "JIR-2321",
        "name": "Single Lever Basin Mixer",
        "price": 5165
      },
      {
        "model": "JIR-2322",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 6795,
        "img": "/assets/cutouts/iris/jir-2322.jpg"
      },
      {
        "model": "JIR-2314",
        "name": "Center Hole Basin Mixer with 18\" Braided Pipe",
        "price": 5040,
        "img": "/assets/cutouts/iris/jir-2314.jpg"
      },
      {
        "model": "JIR-2312",
        "name": "Pillar Cock",
        "price": 1560,
        "img": "/assets/cutouts/iris/jir-2312.jpg"
      },
      {
        "model": "JIR-2312A",
        "name": "Pillar Cock Premium",
        "price": 2025
      },
      {
        "model": "JIR-2333",
        "name": "Pillar Cock 6\"",
        "price": 2530,
        "img": "/assets/cutouts/iris/jir-2333.jpg"
      },
      {
        "model": "JIR-2331",
        "name": "Pillar Cock 7\"",
        "price": 3080
      },
      {
        "model": "JIR-2332",
        "name": "Pillar Cock 9\"",
        "price": 3530
      },
      {
        "model": "JIR-2313",
        "name": "Pillar Cock Extended Body",
        "price": 3650
      },
      {
        "model": "JIR-2330",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3705
      },
      {
        "model": "JIR-2301",
        "name": "Bib Cock with Flange",
        "price": 1220
      },
      {
        "model": "JIR-2302",
        "name": "Long Body Bib Cock with Flange",
        "price": 1275,
        "img": "/assets/cutouts/iris/jir-2302.jpg"
      },
      {
        "model": "JIR-2303",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1295,
        "img": "/assets/cutouts/iris/jir-2303.jpg"
      },
      {
        "model": "JIR-2304",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1865,
        "img": "/assets/cutouts/iris/jir-2304.jpg"
      },
      {
        "model": "JIR-2309",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1995,
        "img": "/assets/cutouts/iris/jir-2309.jpg"
      },
      {
        "model": "JIR-2305",
        "name": "Angle Valve with Flange",
        "price": 880,
        "img": "/assets/cutouts/iris/jir-2305.jpg"
      },
      {
        "model": "JIR-2306",
        "name": "Concealed Stop Cock 15mm",
        "price": 715
      },
      {
        "model": "JIR-2307",
        "name": "Concealed Stop Cock 20mm",
        "price": 715,
        "img": "/assets/cutouts/iris/jir-2307.jpg"
      },
      {
        "model": "JIR-2318",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 6710
      },
      {
        "model": "JIR-2319",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 6705,
        "img": "/assets/cutouts/iris/jir-2319.jpg"
      },
      {
        "model": "JIR-2320",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 7320,
        "img": "/assets/cutouts/iris/jir-2320.jpg"
      },
      {
        "model": "JIR-2315",
        "name": "Sink Cock",
        "price": 2180,
        "img": "/assets/cutouts/iris/jir-2315.jpg"
      },
      {
        "model": "JIR-2315A",
        "name": "Sink Cock Multi Flow Silicon Spout",
        "price": 2390,
        "img": "/assets/cutouts/iris/jir-2315a.jpg"
      },
      {
        "model": "JIR-2315B",
        "name": "Sink Cock Single Flow Silicon Spout",
        "price": 2180
      },
      {
        "model": "JIR-2315 (PR)",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2975,
        "img": "/assets/cutouts/iris/jir-2315.jpg"
      },
      {
        "model": "JIR-2316",
        "name": "Swan Neck",
        "price": 2515,
        "img": "/assets/cutouts/iris/jir-2316.jpg"
      },
      {
        "model": "JIR-2316A",
        "name": "Swan Neck Multi Flow Silicon Spout",
        "price": 2725,
        "img": "/assets/cutouts/iris/jir-2316a.jpg"
      },
      {
        "model": "JIR-2316B",
        "name": "Swan Neck Single Flow Silicon Spout",
        "price": 2490,
        "img": "/assets/cutouts/iris/jir-2316b.jpg"
      },
      {
        "model": "JIR-2316 (PR)",
        "name": "Swan Neck S. Flow Silicon Spout (Premium)",
        "price": 3305,
        "img": "/assets/cutouts/iris/jir-2316.jpg"
      },
      {
        "model": "JIR-2317",
        "name": "Sink Mixer Q.T.",
        "price": 5020,
        "img": "/assets/cutouts/iris/jir-2317.jpg"
      },
      {
        "model": "JIR-2317A",
        "name": "Sink Mixer Multi Flow Silicon Spout",
        "price": 5440,
        "img": "/assets/cutouts/iris/jir-2317a.jpg"
      },
      {
        "model": "JIR-2317B",
        "name": "Sink Mixer Single Flow Silicon Spout",
        "price": 5070
      },
      {
        "model": "JIR-2317 (PR)",
        "name": "Sink Mixer S. Flow Silicon Spout (Premium)",
        "price": 5840,
        "img": "/assets/cutouts/iris/jir-2317.jpg"
      },
      {
        "model": "JIR-2310",
        "name": "Bath Tub Spout (Plain)",
        "price": 1505,
        "img": "/assets/cutouts/iris/jir-2310.jpg"
      },
      {
        "model": "JIR-2311",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2245,
        "img": "/assets/cutouts/iris/jir-2311.jpg"
      },
      {
        "model": "JIR-2328",
        "name": "Table Mounted Single Lever Sink Mixer",
        "price": 8190,
        "img": "/assets/cutouts/iris/jir-2328.jpg"
      },
      {
        "model": "JIR-2326",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 3865,
        "img": "/assets/cutouts/iris/jir-2326.jpg"
      },
      {
        "model": "JIR-2323",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 1880,
        "img": "/assets/cutouts/iris/jir-2323.jpg"
      },
      {
        "model": "JIR-2323B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2180
      },
      {
        "model": "JIR-2324",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2170,
        "img": "/assets/cutouts/iris/jir-2324.jpg"
      },
      {
        "model": "JIR-2325",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2170,
        "img": "/assets/cutouts/iris/jir-2325.jpg"
      },
      {
        "model": "JIR-2329",
        "name": "Single Lever 3-Way Diverter (exposed parts)",
        "price": 3220,
        "img": "/assets/cutouts/iris/jir-2329.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p26.jpg",
      "/assets/pages_clean/p27.jpg",
      "/assets/pages_clean/p28.jpg",
      "/assets/pages_clean/p29.jpg"
    ]
  },
  {
    "id": "ruby",
    "name": "Ruby",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/ruby.jpg",
    "blurb": "Bold stance, precise control, lasting shine.",
    "featured": {
      "model": "JRB-2821",
      "name": "Single Lever Basin Mixer",
      "price": 4570
    },
    "items": [
      {
        "model": "JRB-2821",
        "name": "Single Lever Basin Mixer",
        "price": 4570
      },
      {
        "model": "JRB-2822",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 6190
      },
      {
        "model": "JRB-2814",
        "name": "Center Hole Basin Mixer with 18\" Braided Pipe",
        "price": 4590,
        "img": "/assets/cutouts/ruby/jrb-2814.jpg"
      },
      {
        "model": "JRB-2812",
        "name": "Pillar Cock",
        "price": 1415,
        "img": "/assets/cutouts/ruby/jrb-2812.jpg"
      },
      {
        "model": "JRB-2813",
        "name": "Pillar Cock Extended Body",
        "price": 3625,
        "img": "/assets/cutouts/ruby/jrb-2813.jpg"
      },
      {
        "model": "JRB-2830",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3690
      },
      {
        "model": "JRB-2801",
        "name": "Bib Cock with Flange",
        "price": 1135
      },
      {
        "model": "JRB-2802",
        "name": "Long Body Bib Cock with Flange",
        "price": 1210
      },
      {
        "model": "JRB-2803",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1210
      },
      {
        "model": "JRB-2804",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1725,
        "img": "/assets/cutouts/ruby/jrb-2804.jpg"
      },
      {
        "model": "JRB-2804A",
        "name": "Bib Cock 2-in-1 Double Handle with Flange",
        "price": 1890,
        "img": "/assets/cutouts/ruby/jrb-2804a.jpg"
      },
      {
        "model": "JRB-2809",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1890,
        "img": "/assets/cutouts/ruby/jrb-2809.jpg"
      },
      {
        "model": "JRB-2805",
        "name": "Angle Valve with Flange",
        "price": 710,
        "img": "/assets/cutouts/ruby/jrb-2805.jpg"
      },
      {
        "model": "JRB-2806",
        "name": "Concealed Stop Cock 15mm",
        "price": 685,
        "img": "/assets/cutouts/ruby/jrb-2806.jpg"
      },
      {
        "model": "JRB-2807",
        "name": "Concealed Stop Cock 20mm",
        "price": 685,
        "img": "/assets/cutouts/ruby/jrb-2807.jpg"
      },
      {
        "model": "JRB-2818",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 5995
      },
      {
        "model": "JRB-2819",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 5975,
        "img": "/assets/cutouts/ruby/jrb-2819.jpg"
      },
      {
        "model": "JRB-2820",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 8970
      },
      {
        "model": "JRB-2815",
        "name": "Sink Cock",
        "price": 2095,
        "img": "/assets/cutouts/ruby/jrb-2815.jpg"
      },
      {
        "model": "JRB-2815A",
        "name": "Sink Cock Multi Flow Silicon Spout",
        "price": 2285,
        "img": "/assets/cutouts/ruby/jrb-2815a.jpg"
      },
      {
        "model": "JRB-2815B",
        "name": "Sink Cock Single Flow Silicon Spout",
        "price": 2065,
        "img": "/assets/cutouts/ruby/jrb-2815b.jpg"
      },
      {
        "model": "JRB-2815 (PR)",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2870,
        "img": "/assets/cutouts/ruby/jrb-2815.jpg"
      },
      {
        "model": "JRB-2816",
        "name": "Swan Neck",
        "price": 2335,
        "img": "/assets/cutouts/ruby/jrb-2816.jpg"
      },
      {
        "model": "JRB-2816A",
        "name": "Swan Neck Multi Flow Silicon Spout",
        "price": 2560,
        "img": "/assets/cutouts/ruby/jrb-2816a.jpg"
      },
      {
        "model": "JRB-2816B",
        "name": "Swan Neck Single Flow Silicon Spout",
        "price": 2335,
        "img": "/assets/cutouts/ruby/jrb-2816b.jpg"
      },
      {
        "model": "JRB-2816 (PR)",
        "name": "Swan Neck S. Flow Silicon Spout (Premium)",
        "price": 3140,
        "img": "/assets/cutouts/ruby/jrb-2816.jpg"
      },
      {
        "model": "JRB-2817",
        "name": "Sink Mixer Q.T.",
        "price": 4570,
        "img": "/assets/cutouts/ruby/jrb-2817.jpg"
      },
      {
        "model": "JRB-2817A",
        "name": "Sink Mixer Multi Flow Silicon Spout",
        "price": 4840,
        "img": "/assets/cutouts/ruby/jrb-2817a.jpg"
      },
      {
        "model": "JRB-2817B",
        "name": "Sink Mixer Single Flow Silicon Spout",
        "price": 4570
      },
      {
        "model": "JRB-2817 (PR)",
        "name": "Sink Mixer S. Flow Silicon Spout (Premium)",
        "price": 5380,
        "img": "/assets/cutouts/ruby/jrb-2817.jpg"
      },
      {
        "model": "JRB-2810",
        "name": "Bath Tub Spout (Plain)",
        "price": 1870,
        "img": "/assets/cutouts/ruby/jrb-2810.jpg"
      },
      {
        "model": "JRB-2811",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2690,
        "img": "/assets/cutouts/ruby/jrb-2811.jpg"
      },
      {
        "model": "JRB-2826",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 4120,
        "img": "/assets/cutouts/ruby/jrb-2826.jpg"
      },
      {
        "model": "JRB-2823",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 1840,
        "img": "/assets/cutouts/ruby/jrb-2823.jpg"
      },
      {
        "model": "JRB-2823B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2170,
        "img": "/assets/cutouts/ruby/jrb-2823b.jpg"
      },
      {
        "model": "JRB-2824",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2160,
        "img": "/assets/cutouts/ruby/jrb-2824.jpg"
      },
      {
        "model": "JRB-2825",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2160
      },
      {
        "model": "JRB-2829",
        "name": "Single Lever Concealed 3-Way Diverter",
        "price": 3220
      }
    ],
    "pages": [
      "/assets/pages_clean/p30.jpg",
      "/assets/pages_clean/p31.jpg",
      "/assets/pages_clean/p32.jpg",
      "/assets/pages_clean/p33.jpg"
    ]
  },
  {
    "id": "victor",
    "name": "Victor",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/victor.jpg",
    "blurb": "Confident geometry, engineered for the everyday ritual.",
    "featured": {
      "model": "JVC-2921",
      "name": "Single Lever Basin Mixer",
      "price": 4570
    },
    "items": [
      {
        "model": "JVC-2921",
        "name": "Single Lever Basin Mixer",
        "price": 4570
      },
      {
        "model": "JVC-2922",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 6190,
        "img": "/assets/cutouts/victor/jvc-2922.jpg"
      },
      {
        "model": "JVC-2914",
        "name": "Center Hole Basin Mixer with 18\" Braided Pipe",
        "price": 4590
      },
      {
        "model": "JVC-2912",
        "name": "Pillar Cock",
        "price": 1415,
        "img": "/assets/cutouts/victor/jvc-2912.jpg"
      },
      {
        "model": "JVC-2913",
        "name": "Pillar Cock Extended Body",
        "price": 3625
      },
      {
        "model": "JVC-2930",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3690
      },
      {
        "model": "JVC-2901",
        "name": "Bib Cock with Flange",
        "price": 1135
      },
      {
        "model": "JVC-2902",
        "name": "Long Body Bib Cock with Flange",
        "price": 1210
      },
      {
        "model": "JVC-2903",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1210,
        "img": "/assets/cutouts/victor/jvc-2903.jpg"
      },
      {
        "model": "JVC-2904",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1725
      },
      {
        "model": "JVC-2904A",
        "name": "Bib Cock 2-in-1 Double Handle with Flange",
        "price": 1890,
        "img": "/assets/cutouts/victor/jvc-2904a.jpg"
      },
      {
        "model": "JVC-2909",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1890
      },
      {
        "model": "JVC-2905",
        "name": "Angle Valve with Flange",
        "price": 710,
        "img": "/assets/cutouts/victor/jvc-2905.jpg"
      },
      {
        "model": "JVC-2906",
        "name": "Concealed Stop Cock 15mm",
        "price": 685,
        "img": "/assets/cutouts/victor/jvc-2906.jpg"
      },
      {
        "model": "JVC-2907",
        "name": "Concealed Stop Cock 20mm",
        "price": 685
      },
      {
        "model": "JVC-2918",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 5995
      },
      {
        "model": "JVC-2919",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 5975,
        "img": "/assets/cutouts/victor/jvc-2919.jpg"
      },
      {
        "model": "JVC-2920",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 6970
      },
      {
        "model": "JVC-2915",
        "name": "Sink Cock",
        "price": 2095,
        "img": "/assets/cutouts/victor/jvc-2915.jpg"
      },
      {
        "model": "JVC-2915B",
        "name": "Sink Cock Single Flow Silicon Spout",
        "price": 2065,
        "img": "/assets/cutouts/victor/jvc-2915b.jpg"
      },
      {
        "model": "JVC-2915 (PR)",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2870,
        "img": "/assets/cutouts/victor/jvc-2915.jpg"
      },
      {
        "model": "JVC-2916",
        "name": "Swan Neck",
        "price": 2335,
        "img": "/assets/cutouts/victor/jvc-2916.jpg"
      },
      {
        "model": "JVC-2916A",
        "name": "Swan Neck Multi Flow Silicon Spout",
        "price": 2560,
        "img": "/assets/cutouts/victor/jvc-2916a.jpg"
      },
      {
        "model": "JVC-2916B",
        "name": "Swan Neck Single Flow Silicon Spout",
        "price": 2335,
        "img": "/assets/cutouts/victor/jvc-2916b.jpg"
      },
      {
        "model": "JVC-2916 (PR)",
        "name": "Swan Neck S. Flow Silicon Spout (Premium)",
        "price": 3140,
        "img": "/assets/cutouts/victor/jvc-2916.jpg"
      },
      {
        "model": "JVC-2917",
        "name": "Sink Mixer Q.T.",
        "price": 4570,
        "img": "/assets/cutouts/victor/jvc-2917.jpg"
      },
      {
        "model": "JVC-2917A",
        "name": "Sink Mixer Multi Flow Silicon Spout",
        "price": 4840,
        "img": "/assets/cutouts/victor/jvc-2917a.jpg"
      },
      {
        "model": "JVC-2917B",
        "name": "Sink Mixer Single Flow Silicon Spout",
        "price": 4570,
        "img": "/assets/cutouts/victor/jvc-2917b.jpg"
      },
      {
        "model": "JVC-2917 (PR)",
        "name": "Sink Mixer S. Flow Silicon Spout (Premium)",
        "price": 5380,
        "img": "/assets/cutouts/victor/jvc-2917.jpg"
      },
      {
        "model": "JVC-2910",
        "name": "Bath Tub Spout (Plain)",
        "price": 1870,
        "img": "/assets/cutouts/victor/jvc-2910.jpg"
      },
      {
        "model": "JVC-2911",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 2690
      },
      {
        "model": "JVC-2926",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 4120,
        "img": "/assets/cutouts/victor/jvc-2926.jpg"
      },
      {
        "model": "JVC-2923",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 1840
      },
      {
        "model": "JVC-2923B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2170
      },
      {
        "model": "JVC-2924",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2160
      },
      {
        "model": "JVC-2925",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2160,
        "img": "/assets/cutouts/victor/jvc-2925.jpg"
      },
      {
        "model": "JVC-2929",
        "name": "Single Lever Concealed 3-Way Diverter",
        "price": 3220
      }
    ],
    "pages": [
      "/assets/pages_clean/p34.jpg",
      "/assets/pages_clean/p35.jpg",
      "/assets/pages_clean/p36.jpg",
      "/assets/pages_clean/p37.jpg"
    ]
  },
  {
    "id": "saffron",
    "name": "Saffron",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/saffron.jpg",
    "blurb": "Warm character drawn from Indian craft traditions.",
    "featured": {
      "model": "JSF-1921",
      "name": "Single Lever Basin Mixer",
      "price": 3930
    },
    "items": [
      {
        "model": "JSF-1921",
        "name": "Single Lever Basin Mixer",
        "price": 3930
      },
      {
        "model": "JSF-1922",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 8270
      },
      {
        "model": "JSF-1912",
        "name": "Pillar Cock",
        "price": 1265
      },
      {
        "model": "JSF-1912A",
        "name": "Pillar Cock Premium",
        "price": 1575
      },
      {
        "model": "JSF-1913",
        "name": "Pillar Cock Extended Body",
        "price": 3030,
        "img": "/assets/cutouts/saffron/jsf-1913.jpg"
      },
      {
        "model": "JSF-1931",
        "name": "Pillar Cock 7\"",
        "price": 2510,
        "img": "/assets/cutouts/saffron/jsf-1931.jpg"
      },
      {
        "model": "JSF-1930",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3510,
        "img": "/assets/cutouts/saffron/jsf-1930.jpg"
      },
      {
        "model": "JSF-1901",
        "name": "Bib Cock with Flange",
        "price": 1105
      },
      {
        "model": "JSF-1902",
        "name": "Long Body Bib Cock with Flange",
        "price": 1235
      },
      {
        "model": "JSF-1902A",
        "name": "Bib Cock Long Nose",
        "price": 1390
      },
      {
        "model": "JSF-1903",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1160
      },
      {
        "model": "JSF-1904",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1735,
        "img": "/assets/cutouts/saffron/jsf-1904.jpg"
      },
      {
        "model": "JSF-1909",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1805,
        "img": "/assets/cutouts/saffron/jsf-1909.jpg"
      },
      {
        "model": "JSF-1905",
        "name": "Angle Valve with Flange",
        "price": 735
      },
      {
        "model": "JSF-1906",
        "name": "Concealed Stop Cock 15mm",
        "price": 675
      },
      {
        "model": "JSF-1907",
        "name": "Concealed Stop Cock 20mm",
        "price": 675
      },
      {
        "model": "JSF-1918",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 5985,
        "img": "/assets/cutouts/saffron/jsf-1918.jpg"
      },
      {
        "model": "JSF-1919",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 5810,
        "img": "/assets/cutouts/saffron/jsf-1919.jpg"
      },
      {
        "model": "JSF-1920",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 6510,
        "img": "/assets/cutouts/saffron/jsf-1920.jpg"
      },
      {
        "model": "JSF-1933",
        "name": "Wall Mixer Non-Telephonic",
        "price": 4755,
        "img": "/assets/cutouts/saffron/jsf-1933.jpg"
      },
      {
        "model": "JSF-1915",
        "name": "Sink Cock",
        "price": 1985,
        "img": "/assets/cutouts/saffron/jsf-1915.jpg"
      },
      {
        "model": "JSF-1915A",
        "name": "Sink Cock M. Flow Silicon Spout",
        "price": 2310
      },
      {
        "model": "JSF-1915B",
        "name": "Sink Cock S. Flow Silicon Spout (Regular)",
        "price": 1985
      },
      {
        "model": "JSF-1915 (PR)",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2940,
        "img": "/assets/cutouts/saffron/jsf-1915.jpg"
      },
      {
        "model": "JSF-1916",
        "name": "Swan Neck",
        "price": 2425,
        "img": "/assets/cutouts/saffron/jsf-1916.jpg"
      },
      {
        "model": "JSF-1916B",
        "name": "Swan Neck S. Flow Silicon Spout (Regular)",
        "price": 2840
      },
      {
        "model": "JSF-1916 (PR)",
        "name": "Swan Neck S. Flow Silicon Spout (Premium)",
        "price": 3410,
        "img": "/assets/cutouts/saffron/jsf-1916.jpg"
      },
      {
        "model": "JSF-1917",
        "name": "Sink Mixer Q.T.",
        "price": 4695,
        "img": "/assets/cutouts/saffron/jsf-1917.jpg"
      },
      {
        "model": "JSF-1917A",
        "name": "Sink Mixer M. Flow Silicon Spout",
        "price": 4960
      },
      {
        "model": "JSF-1917B",
        "name": "Sink Mixer S. Flow Silicon Spout",
        "price": 4695
      },
      {
        "model": "JSF-1917 (PR)",
        "name": "Sink Mixer S. Flow Silicon Spout (Premium)",
        "price": 5445,
        "img": "/assets/cutouts/saffron/jsf-1917.jpg"
      },
      {
        "model": "JSF-1910",
        "name": "Bath Tub Spout (Plain)",
        "price": 1115
      },
      {
        "model": "JSF-1911",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 1855
      },
      {
        "model": "JSF-1926",
        "name": "Wall Mounted Single Lever Concealed Basin Mixer (exposed parts)",
        "price": 3915
      },
      {
        "model": "JSF-1923",
        "name": "Single Lever Concealed Diverter High Flow Tipton (exposed parts)",
        "price": 1800,
        "img": "/assets/cutouts/saffron/jsf-1923.jpg"
      },
      {
        "model": "JSF-1923B",
        "name": "Single Lever Concealed Diverter High Flow Rotary (exposed parts)",
        "price": 2120
      },
      {
        "model": "JSF-1924",
        "name": "Single Lever Concealed Diverter High Flow 45mm (exposed parts)",
        "price": 2095
      },
      {
        "model": "JSF-1925",
        "name": "Single Lever Concealed Diverter 3 Inlet (exposed parts)",
        "price": 2095
      },
      {
        "model": "JSF-1929",
        "name": "Single Lever Concealed 3-Way Diverter (exposed part)",
        "price": 3220
      }
    ],
    "pages": [
      "/assets/pages_clean/p38.jpg",
      "/assets/pages_clean/p39.jpg"
    ]
  },
  {
    "id": "lupine",
    "name": "Lupine",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/lupine.jpg",
    "blurb": "Extended-body pillar cocks and versatile 2-in-1 fittings.",
    "featured": {
      "model": "JLP-3121",
      "name": "Single Lever Basin Mixer",
      "price": 3930
    },
    "items": [
      {
        "model": "JLP-3121",
        "name": "Single Lever Basin Mixer",
        "price": 3930
      },
      {
        "model": "JLP-3122",
        "name": "Single Lever Basin Mixer Extended Body",
        "price": 6270
      },
      {
        "model": "JLP-3112",
        "name": "Pillar Cock",
        "price": 1245,
        "img": "/assets/cutouts/lupine/jlp-3112.jpg"
      },
      {
        "model": "JLP-3112-A",
        "name": "Pillar Cock Premium",
        "price": 1555
      },
      {
        "model": "JLP-3131",
        "name": "Pillar Cock 7\"",
        "price": 2490,
        "img": "/assets/cutouts/lupine/jlp-3131.jpg"
      },
      {
        "model": "JLP-3113",
        "name": "Pillar Cock Extended Body",
        "price": 3010,
        "img": "/assets/cutouts/lupine/jlp-3113.jpg"
      },
      {
        "model": "JLP-3130",
        "name": "Pillar Cock WM (exposed part)",
        "price": 3490
      },
      {
        "model": "JLP-3101",
        "name": "Bib Cock with Flange",
        "price": 1080
      },
      {
        "model": "JLP-3102",
        "name": "Long Body Bib Cock with Flange",
        "price": 1215,
        "img": "/assets/cutouts/lupine/jlp-3102.jpg"
      },
      {
        "model": "JLP-3102A",
        "name": "Bib Cock Long Nose",
        "price": 1370
      },
      {
        "model": "JLP-3103",
        "name": "Pillar Bib Cock with Flange",
        "price": 1140,
        "img": "/assets/cutouts/lupine/jlp-3103.jpg"
      },
      {
        "model": "JLP-3104",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1715,
        "img": "/assets/cutouts/lupine/jlp-3104.jpg"
      },
      {
        "model": "JLP-3104-A",
        "name": "Bib Cock 2-in-1 Double Handle with Flange",
        "price": 1630
      },
      {
        "model": "JLP-3109",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1820,
        "img": "/assets/cutouts/lupine/jlp-3109.jpg"
      },
      {
        "model": "JLP-3105",
        "name": "Angle Valve with Flange",
        "price": 715,
        "img": "/assets/cutouts/lupine/jlp-3105.jpg"
      },
      {
        "model": "JLP-3106",
        "name": "Concealed Stop Cock 15mm",
        "price": 655,
        "img": "/assets/cutouts/lupine/jlp-3106.jpg"
      },
      {
        "model": "JLP-3107",
        "name": "Concealed Stop Cock 20mm",
        "price": 655,
        "img": "/assets/cutouts/lupine/jlp-3107.jpg"
      },
      {
        "model": "JLP-3118",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 5965
      },
      {
        "model": "JLP-3119",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 5790,
        "img": "/assets/cutouts/lupine/jlp-3119.jpg"
      },
      {
        "model": "JLP-3120",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 6490
      },
      {
        "model": "JLP-3108",
        "name": "Wall Mixer Non-Telephonic",
        "price": 4735
      },
      {
        "model": "JLP-3115",
        "name": "Sink Cock",
        "price": 1965
      },
      {
        "model": "JLP-3115A",
        "name": "Sink Cock M. Flow Silicon Spout",
        "price": 2290
      },
      {
        "model": "JLP-3115B",
        "name": "Sink Cock S. Flow Silicon Spout",
        "price": 2090
      },
      {
        "model": "JLP-3115 (PR)",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2920
      },
      {
        "model": "JLP-3116",
        "name": "Swan Neck",
        "price": 2405,
        "img": "/assets/cutouts/lupine/jlp-3116.jpg"
      },
      {
        "model": "JLP-3116A",
        "name": "Swan Neck M. Flow Silicon Spout",
        "price": 2860
      },
      {
        "model": "JLP-3116B",
        "name": "Swan Neck S. Flow Silicon Spout",
        "price": 2535
      },
      {
        "model": "JLP-3116 (PR)",
        "name": "Swan Neck S. Flow Silicon Spout (Premium)",
        "price": 3390,
        "img": "/assets/cutouts/lupine/jlp-3116.jpg"
      },
      {
        "model": "JLP-3117",
        "name": "Sink Mixer Q.T.",
        "price": 4675,
        "img": "/assets/cutouts/lupine/jlp-3117.jpg"
      },
      {
        "model": "JLP-3117A",
        "name": "Sink Mixer M. Flow Silicon Spout",
        "price": 4990
      },
      {
        "model": "JLP-3117B",
        "name": "Sink Mixer S. Flow Silicon Spout",
        "price": 4685
      },
      {
        "model": "JLP-3117 (PR)",
        "name": "Sink Mixer S. Flow Silicon Spout (Premium)",
        "price": 5625,
        "img": "/assets/cutouts/lupine/jlp-3117.jpg"
      },
      {
        "model": "JLP-3110",
        "name": "Bath Tub Spout (Plain)",
        "price": 1115,
        "img": "/assets/cutouts/lupine/jlp-3110.jpg"
      },
      {
        "model": "JLP-3111",
        "name": "Bath Tub Spout with Tip Ton for Telephonic Shower",
        "price": 1855,
        "img": "/assets/cutouts/lupine/jlp-3111.jpg"
      },
      {
        "model": "JLP-3126",
        "name": "WM Single Lever Basin Mixer (exposed part)",
        "price": 3915
      },
      {
        "model": "JLP-3123",
        "name": "SL Concealed Diverter Hi-Flow Tipton (exposed part)",
        "price": 1800
      },
      {
        "model": "JLP-3123B",
        "name": "SL Concealed Diverter Hi-Flow Rotary (exposed part)",
        "price": 2120
      },
      {
        "model": "JLP-3124",
        "name": "SL Concealed Diverter Hi-Flow 45mm (exposed part)",
        "price": 2095
      },
      {
        "model": "JLP-3125",
        "name": "SL Concealed Diverter 3 Inlet (exposed part)",
        "price": 2095
      },
      {
        "model": "JLP-3129",
        "name": "SL Concealed 3-Way Diverter (exposed part)",
        "price": 3220
      }
    ],
    "pages": [
      "/assets/pages_clean/p40.jpg",
      "/assets/pages_clean/p41.jpg",
      "/assets/pages_clean/p42.jpg",
      "/assets/pages_clean/p43.jpg"
    ]
  },
  {
    "id": "cosmo",
    "name": "Cosmo",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/cosmo.jpg",
    "blurb": "Compact, cosmopolitan forms for contemporary spaces.",
    "featured": {
      "model": "JCO-13017",
      "name": "Sink Mixer Q.T.",
      "price": 4605
    },
    "items": [
      {
        "model": "JCO-13012",
        "name": "Pillar Cock",
        "price": 1430,
        "img": "/assets/cutouts/cosmo/jco-13012.jpg"
      },
      {
        "model": "JCO-13013",
        "name": "Pillar Cock Extended Body",
        "price": 3095,
        "img": "/assets/cutouts/cosmo/jco-13013.jpg"
      },
      {
        "model": "JCO-13001",
        "name": "Bib Cock with Flange",
        "price": 1095
      },
      {
        "model": "JCO-13002",
        "name": "Long Body Bib Cock with Flange",
        "price": 1180
      },
      {
        "model": "JCO-13003",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1175,
        "img": "/assets/cutouts/cosmo/jco-13003.jpg"
      },
      {
        "model": "JCO-13004",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1720
      },
      {
        "model": "JCO-13009",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1845
      },
      {
        "model": "JCO-13005",
        "name": "Angle Valve with Flange",
        "price": 895,
        "img": "/assets/cutouts/cosmo/jco-13005.jpg"
      },
      {
        "model": "JCO-13006",
        "name": "Concealed Stop Cock 15mm",
        "price": 675,
        "img": "/assets/cutouts/cosmo/jco-13006.jpg"
      },
      {
        "model": "JCO-13007",
        "name": "Concealed Stop Cock 20mm",
        "price": 675,
        "img": "/assets/cutouts/cosmo/jco-13007.jpg"
      },
      {
        "model": "JCO-13018",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 6145,
        "img": "/assets/cutouts/cosmo/jco-13018.jpg"
      },
      {
        "model": "JCO-13019",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 6145,
        "img": "/assets/cutouts/cosmo/jco-13019.jpg"
      },
      {
        "model": "JCO-13020",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 6755,
        "img": "/assets/cutouts/cosmo/jco-13020.jpg"
      },
      {
        "model": "JCO-13015",
        "name": "Sink Cock",
        "price": 1960,
        "img": "/assets/cutouts/cosmo/jco-13015.jpg"
      },
      {
        "model": "JCO-1315 B",
        "name": "Sink Cock Silicon Spout (Regular)",
        "price": 1960
      },
      {
        "model": "JCO-1315 (PR)",
        "name": "Sink Cock Silicon Spout (Premium)",
        "price": 2770,
        "img": "/assets/cutouts/cosmo/jco-1315.jpg"
      },
      {
        "model": "JCO-13016",
        "name": "Swan Neck",
        "price": 2390,
        "img": "/assets/cutouts/cosmo/jco-13016.jpg"
      },
      {
        "model": "JCO-13017",
        "name": "Sink Mixer Q.T.",
        "price": 4605,
        "img": "/assets/cutouts/cosmo/jco-13017.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p44.jpg",
      "/assets/pages_clean/p45.jpg"
    ]
  },
  {
    "id": "flora",
    "name": "Flora",
    "category": "faucets",
    "line": "Single Lever Cartridge",
    "image": "/assets/img/flora.jpg",
    "blurb": "Organic lines inspired by petal and stem.",
    "featured": {
      "model": "JFL-12017",
      "name": "Sink Mixer Q.T.",
      "price": 4585
    },
    "items": [
      {
        "model": "JFL-12012",
        "name": "Pillar Cock",
        "price": 1410
      },
      {
        "model": "JFL-12013",
        "name": "Pillar Cock Extended Body",
        "price": 3340,
        "img": "/assets/cutouts/flora/jfl-12013.jpg"
      },
      {
        "model": "JFL-12001",
        "name": "Bib Cock with Flange",
        "price": 1075
      },
      {
        "model": "JFL-12002",
        "name": "Long Body Bib Cock with Flange",
        "price": 1160,
        "img": "/assets/cutouts/flora/jfl-12002.jpg"
      },
      {
        "model": "JFL-12003",
        "name": "Nozzle Bib Cock with Flange",
        "price": 1155,
        "img": "/assets/cutouts/flora/jfl-12003.jpg"
      },
      {
        "model": "JFL-12004",
        "name": "Bib Cock 2-in-1 Single Handle with Flange",
        "price": 1700,
        "img": "/assets/cutouts/flora/jfl-12004.jpg"
      },
      {
        "model": "JFL-12009",
        "name": "Angle Valve 2-in-1 with Flange",
        "price": 1825,
        "img": "/assets/cutouts/flora/jfl-12009.jpg"
      },
      {
        "model": "JFL-12005",
        "name": "Angle Valve with Flange",
        "price": 675,
        "img": "/assets/cutouts/flora/jfl-12005.jpg"
      },
      {
        "model": "JFL-12006",
        "name": "Concealed Stop Cock 15mm",
        "price": 655,
        "img": "/assets/cutouts/flora/jfl-12006.jpg"
      },
      {
        "model": "JFL-12007",
        "name": "Concealed Stop Cock 20mm",
        "price": 655,
        "img": "/assets/cutouts/flora/jfl-12007.jpg"
      },
      {
        "model": "JFL-12018",
        "name": "Wall Mixer Telephonic Arrangement with Crutch",
        "price": 6125,
        "img": "/assets/cutouts/flora/jfl-12018.jpg"
      },
      {
        "model": "JFL-12019",
        "name": "Wall Mixer 2-in-1 with Bend Pipe for Overhead Shower",
        "price": 6125
      },
      {
        "model": "JFL-12020",
        "name": "Wall Mixer 3-in-1 with Bend Pipe & Telephonic Arrangement",
        "price": 6735,
        "img": "/assets/cutouts/flora/jfl-12020.jpg"
      },
      {
        "model": "JFL-12015",
        "name": "Sink Cock",
        "price": 1940,
        "img": "/assets/cutouts/flora/jfl-12015.jpg"
      },
      {
        "model": "JFL-12015B",
        "name": "Sink Cock S. Flow Silicon Spout",
        "price": 1940
      },
      {
        "model": "JFL-12015 (PR)",
        "name": "Sink Cock S. Flow Silicon Spout (Premium)",
        "price": 2740,
        "img": "/assets/cutouts/flora/jfl-12015.jpg"
      },
      {
        "model": "JFL-12016",
        "name": "Swan Neck",
        "price": 2370,
        "img": "/assets/cutouts/flora/jfl-12016.jpg"
      },
      {
        "model": "JFL-12017",
        "name": "Sink Mixer Q.T.",
        "price": 4585,
        "img": "/assets/cutouts/flora/jfl-12017.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p46.jpg",
      "/assets/pages_clean/p47.jpg"
    ]
  },
  {
    "id": "kitchen",
    "name": "Kitchen Faucets",
    "category": "kitchen",
    "line": "Culinary Series",
    "image": "/assets/img/kitchen.jpg",
    "blurb": "Swan necks, sink mixers and silicon spouts built for the working kitchen.",
    "featured": {
      "model": "JKF-6606",
      "name": "Table Mounted Single Lever Sink Mixer",
      "price": 8870
    },
    "items": [
      {
        "model": "JKF-6601",
        "name": "Single Lever Sink Mixer WM 200mm Spout",
        "price": 9540,
        "img": "/assets/cutouts/kitchen/jkf-6601.jpg"
      },
      {
        "model": "JKF-6603",
        "name": "Sink Cock",
        "price": 3935,
        "img": "/assets/cutouts/kitchen/jkf-6603.jpg"
      },
      {
        "model": "JKF-6604",
        "name": "Sink Mixer (Double Handle)",
        "price": 8615,
        "img": "/assets/cutouts/kitchen/jkf-6604.jpg"
      },
      {
        "model": "JKF-6605",
        "name": "Table Mounted Sink Cock",
        "price": 4780,
        "img": "/assets/cutouts/kitchen/jkf-6605.jpg"
      },
      {
        "model": "JKF-6606",
        "name": "Table Mounted Single Lever Sink Mixer",
        "price": 8870,
        "img": "/assets/cutouts/kitchen/jkf-6606.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p49.jpg"
    ]
  },
  {
    "id": "project",
    "name": "Project Range",
    "category": "faucets",
    "line": "Project & Mouth Operated",
    "image": "/assets/img/health.jpg",
    "blurb": "Hard-working angle valves and mouth-operated taps for commercial projects.",
    "featured": {
      "model": "JMO-5501A",
      "name": "Mouth Operating Pillar Cock",
      "price": 3885
    },
    "items": [
      {
        "model": "JPA-5526",
        "name": "Angle Valve with Flange",
        "price": 640
      },
      {
        "model": "JPA-5527",
        "name": "Angle Valve Long Thread with Wall Flange",
        "price": 715
      },
      {
        "model": "JPA-5528",
        "name": "Angle Valve with Flange (Compact)",
        "price": 610
      },
      {
        "model": "JPA-5529",
        "name": "Angle Valve Extended with Wall Flange",
        "price": 915
      },
      {
        "model": "JPR-2915BS",
        "name": "Sink Cock SS Big Spout",
        "price": 2135
      },
      {
        "model": "JPR-5050 SS",
        "name": "Sink Cock SS Medium Spout",
        "price": 1885
      },
      {
        "model": "JMO-5501A",
        "name": "Mouth Operating Pillar Cock",
        "price": 3885,
        "img": "/assets/cutouts/kitchen/jmo-5501a.jpg"
      },
      {
        "model": "JMO-5501B",
        "name": "Mouth Operating Extended Pillar Cock 12\"",
        "price": 4960,
        "img": "/assets/cutouts/kitchen/jmo-5501b.jpg"
      },
      {
        "model": "JMO-5503",
        "name": "Mouth Operating Bib Cock",
        "price": 2440,
        "img": "/assets/cutouts/kitchen/jmo-5503.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p48.jpg"
    ]
  },
  {
    "id": "watersaver",
    "name": "Water Saver & Flush",
    "category": "faucets",
    "line": "Pressmatic Series",
    "image": "/assets/img/drainers.jpg",
    "blurb": "Self-closing Pressmatic taps and concealed flush valves that save every drop.",
    "featured": {
      "model": "JWS-6005",
      "name": "Pressmatic Wall Mounted Basin Tap",
      "price": 6285
    },
    "items": [
      {
        "model": "JWS-6001A",
        "name": "Pressmatic Pillar Cock Straight Line",
        "price": 3150
      },
      {
        "model": "JWS-6002",
        "name": "Pressmatic Angle Valve with Flow Control",
        "price": 3455
      },
      {
        "model": "JWS-6003",
        "name": "Pressmatic Bib Cock with Flow Control",
        "price": 3280,
        "img": "/assets/cutouts/watersaver/jws-6003.jpg"
      },
      {
        "model": "JWS-6004",
        "name": "Pressmatic Angle Valve",
        "price": 2010
      },
      {
        "model": "JWS-6005",
        "name": "Pressmatic Wall Mounted Basin Tap",
        "price": 6285
      },
      {
        "model": "JWS-6006",
        "name": "Pressmatic Bib Cock",
        "price": 2790
      },
      {
        "model": "JBW-6008",
        "name": "Concealed Flush Valve 32mm (Dual) Metropole Type",
        "price": 6480
      },
      {
        "model": "JWS-6008A",
        "name": "Concealed Flush Valve 40mm (Dual) Metropole Type",
        "price": 6640
      },
      {
        "model": "JBW-6009",
        "name": "Concealed Flush Valve 32mm (Single) Metropole Type",
        "price": 6190
      },
      {
        "model": "JBW-6009A",
        "name": "Concealed Flush Valve 40mm (Single) Metropole Type",
        "price": 6335
      }
    ],
    "pages": [
      "/assets/pages_clean/p50.jpg"
    ]
  },
  {
    "id": "medi",
    "name": "Medi Series",
    "category": "faucets",
    "line": "Elbow Action Surgical",
    "image": "/assets/img/saffron.jpg",
    "blurb": "Elbow-action surgical taps for hospitals, labs and hygiene-critical spaces.",
    "featured": {
      "model": "JMS-6104",
      "name": "Elbow Action Surgical Single Lever Wall Mixer",
      "price": 11510
    },
    "items": [
      {
        "model": "JMS-6101",
        "name": "Elbow Action Pillar Cock",
        "price": 2925,
        "img": "/assets/cutouts/medi/jms-6101.jpg"
      },
      {
        "model": "JMS-6102",
        "name": "Elbow Action Bib Cock",
        "price": 2765
      },
      {
        "model": "JMS-6103",
        "name": "Elbow Action Surgical Single Lever Basin Mixer",
        "price": 6465,
        "img": "/assets/cutouts/medi/jms-6103.jpg"
      },
      {
        "model": "JMS-6104",
        "name": "Elbow Action Surgical Single Lever Wall Mixer",
        "price": 11510,
        "img": "/assets/cutouts/medi/jms-6104.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p51.jpg"
    ]
  },
  {
    "id": "shower",
    "name": "Showers & Arms",
    "category": "showers",
    "line": "Rain Series",
    "image": "/assets/img/shower.jpg",
    "blurb": "Ceiling and wall-mounted rain showers, telephonic showers and brass arms.",
    "featured": {
      "model": "JSH-9010",
      "name": "12\" S.S. Overhead Shower 300x300mm",
      "price": 3380
    },
    "items": [
      {
        "model": "JSH-9008",
        "name": "6\" S.S. Overhead Shower 150x150mm (w/o Arm)",
        "price": 1140
      },
      {
        "model": "JSH-9009",
        "name": "8\" S.S. Overhead Shower 200x200mm",
        "price": 1500,
        "img": "/assets/cutouts/shower/jsh-9009.jpg"
      },
      {
        "model": "JSH-9010",
        "name": "12\" S.S. Overhead Shower 300x300mm",
        "price": 3380,
        "img": "/assets/cutouts/shower/jsh-9010.jpg"
      },
      {
        "model": "JSH-9020",
        "name": "Cuba 125x125mm",
        "price": 835
      },
      {
        "model": "JSH-9022",
        "name": "3\" Angel 75mm",
        "price": 550
      },
      {
        "model": "JSH-9023",
        "name": "4\" Amara 100mm",
        "price": 760
      },
      {
        "model": "JSH-9025",
        "name": "Overhead Shower 4\" 100x100mm",
        "price": 615
      },
      {
        "model": "JSH-9025",
        "name": "Overhead Shower 5\" 125x125mm",
        "price": 795
      },
      {
        "model": "JSH-9025",
        "name": "Overhead Shower 6\" 150x150mm",
        "price": 1275
      },
      {
        "model": "JSH-9026",
        "name": "Overhead Shower 4\" 100mm",
        "price": 615
      },
      {
        "model": "JSH-9026",
        "name": "Overhead Shower 5\" 125mm",
        "price": 775
      },
      {
        "model": "JSH-9026",
        "name": "Overhead Shower 6\" 150mm",
        "price": 1190
      },
      {
        "model": "JSH-9012-OS",
        "name": "Silver Bell Overhead Shower",
        "price": 625
      },
      {
        "model": "JSA 9101",
        "name": "7\" Round Brass Shower Arm",
        "price": 1015
      },
      {
        "model": "JSA 9102",
        "name": "9\" Round Brass Shower Arm",
        "price": 1255
      },
      {
        "model": "JSA 9107",
        "name": "Round SS Arm SS 202",
        "price": 235
      },
      {
        "model": "JSA 9109",
        "name": "12\" Round 300mm SS 202 Arm",
        "price": 350
      },
      {
        "model": "JSA 9110",
        "name": "15\" Round 375mm SS 202 Arm",
        "price": 445
      },
      {
        "model": "JSA 9111",
        "name": "18\" Round 450mm SS 202 Arm",
        "price": 545
      },
      {
        "model": "JSH-9056",
        "name": "Shower Rail",
        "price": 3410
      },
      {
        "model": "JSH-9051",
        "name": "3\" Cuba Telephonic Shower",
        "price": 1250
      },
      {
        "model": "JSH-9050",
        "name": "3\" Amara Telephonic Shower",
        "price": 1345
      },
      {
        "model": "JSH-9053",
        "name": "Square Sleek Telephonic Shower",
        "price": 1420
      },
      {
        "model": "JSH-9054",
        "name": "Dolphin Telephonic Shower",
        "price": 1620
      },
      {
        "model": "JSH-9055",
        "name": "Jumbo Telephonic Shower",
        "price": 1400
      }
    ],
    "pages": [
      "/assets/pages_clean/p52.jpg",
      "/assets/pages_clean/p53.jpg",
      "/assets/pages_clean/p54.jpg"
    ]
  },
  {
    "id": "health",
    "name": "Health Faucets & Pipes",
    "category": "showers",
    "line": "Hygiene Series",
    "image": "/assets/img/health.jpg",
    "blurb": "SS 304 and ABS health faucets, hooks, connection pipes and shower tubes.",
    "featured": {
      "model": "JHF-6531",
      "name": "Dhruv Health Faucet",
      "price": 2010
    },
    "items": [
      {
        "model": "JHF-6531",
        "name": "Dhruv Health Faucet",
        "price": 2010
      },
      {
        "model": "JHF-6552",
        "name": "SS 304 Tube & Hook Viva Prime",
        "price": 1300
      },
      {
        "model": "JHF-6521",
        "name": "Italian Health Faucet",
        "price": 1100
      },
      {
        "model": "JHF-6518",
        "name": "ABS Health Faucet",
        "price": 1070
      },
      {
        "model": "JHF-6553",
        "name": "SS 304 Tube & Hook Kia",
        "price": 990
      },
      {
        "model": "JHF-6512",
        "name": "ABS Hook (Flat)",
        "price": 85
      },
      {
        "model": "JHF-6511",
        "name": "ABS Hook (Round)",
        "price": 80
      },
      {
        "model": "JBW-6050",
        "name": "SS Connection Pipe Triple Layer with Brass Nut 18\"",
        "price": 365
      },
      {
        "model": "JBW-6051",
        "name": "SS Connection Pipe Triple Layer with Brass Nut 24\"",
        "price": 440
      },
      {
        "model": "JBW-6052",
        "name": "SS Connection Pipe with Brass Nut 18\"",
        "price": 300
      },
      {
        "model": "JBW-6053",
        "name": "SS Connection Pipe with Brass Nut 24\"",
        "price": 355
      },
      {
        "model": "JBW-6054",
        "name": "PVC Connection Pipe with Brass Nut 18\"",
        "price": 270
      },
      {
        "model": "JBW-6055",
        "name": "PVC Connection Pipe with Brass Nut 24\"",
        "price": 300
      },
      {
        "model": "JBW-6056",
        "name": "PVC Connection Pipe with SS Nut 18\"",
        "price": 220
      },
      {
        "model": "JBW-6057",
        "name": "PVC Connection Pipe with SS Nut 24\"",
        "price": 250
      },
      {
        "model": null,
        "name": "Shower Tube Grey 1 mtr",
        "price": 470
      },
      {
        "model": null,
        "name": "Shower Tube Grey 1.5 mtr",
        "price": 520
      },
      {
        "model": "JBW-6058",
        "name": "Shower Tube SS 304 1 mtr",
        "price": 530
      },
      {
        "model": "JBW-6059",
        "name": "Shower Tube SS 304 1.5 mtr",
        "price": 670
      },
      {
        "model": "JBW-6070",
        "name": "Multi Jet Spray with Grey Tube 1 mtr",
        "price": 465
      },
      {
        "model": "JBW-6071",
        "name": "Multi Jet Spray with Grey Tube 1.5 mtr",
        "price": 520
      }
    ],
    "pages": [
      "/assets/pages_clean/p55.jpg"
    ]
  },
  {
    "id": "spark_chrome",
    "name": "Spark Chrome",
    "category": "accessories",
    "line": "Bath Accessories",
    "image": "/assets/img/spark_chrome.jpg",
    "blurb": "Towel racks, rails and rings in flawless mirror chrome.",
    "featured": {
      "model": "JAC-8609",
      "name": "Towel Rack 24\"",
      "price": 3340
    },
    "items": [
      {
        "model": "JAC-8609",
        "name": "Towel Rack 24\"",
        "price": 3340,
        "img": "/assets/cutouts/spark_chrome/jac-8609.jpg"
      },
      {
        "model": "JAC-8601",
        "name": "Towel Rod 24\"",
        "price": 1265,
        "img": "/assets/cutouts/spark_chrome/jac-8601.jpg"
      },
      {
        "model": "JAC-8601A",
        "name": "Towel Rod 18\"",
        "price": 1220,
        "img": "/assets/cutouts/spark_chrome/jac-8601a.jpg"
      },
      {
        "model": "JAC-8602",
        "name": "Towel Ring",
        "price": 1045,
        "img": "/assets/cutouts/spark_chrome/jac-8602.jpg"
      },
      {
        "model": "JAC-8603",
        "name": "Robe Hook",
        "price": 745,
        "img": "/assets/cutouts/spark_chrome/jac-8603.jpg"
      },
      {
        "model": "JAC-8604",
        "name": "Soap Dish",
        "price": 895,
        "img": "/assets/cutouts/spark_chrome/jac-8604.jpg"
      },
      {
        "model": "JAC-8606",
        "name": "Toilet Paper Holder with Flap",
        "price": 1530,
        "img": "/assets/cutouts/spark_chrome/jac-8606.jpg"
      },
      {
        "model": "JAC-8610",
        "name": "Liquid Soap Dispenser",
        "price": 1415,
        "img": "/assets/cutouts/spark_chrome/jac-8610.jpg"
      },
      {
        "model": "JAC-8611",
        "name": "Tooth Brush Holder",
        "price": 1070,
        "img": "/assets/cutouts/spark_chrome/jac-8611.jpg"
      },
      {
        "model": "JAC-8612",
        "name": "Double Soap Dish",
        "price": 1575,
        "img": "/assets/cutouts/spark_chrome/jac-8612.jpg"
      },
      {
        "model": "JAC-8613",
        "name": "Tooth Brush Holder with Soap Dish",
        "price": 1750,
        "img": "/assets/cutouts/spark_chrome/jac-8613.jpg"
      },
      {
        "model": "JAC-8614",
        "name": "Soap Dish with LSD",
        "price": 2030,
        "img": "/assets/cutouts/spark_chrome/jac-8614.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p56.jpg",
      "/assets/pages_clean/p57.jpg"
    ]
  },
  {
    "id": "spark_gold",
    "name": "Spark Gold",
    "category": "accessories",
    "line": "Bath Accessories",
    "image": "/assets/img/spark_gold.jpg",
    "blurb": "Gilded accessories for baths that demand theatre.",
    "featured": {
      "model": "JAC-8409",
      "name": "Towel Rack 24\"",
      "price": 6780
    },
    "items": [
      {
        "model": "JAC-8409",
        "name": "Towel Rack 24\"",
        "price": 6780
      },
      {
        "model": "JAC-8401",
        "name": "Towel Rod 24\"",
        "price": 2470,
        "img": "/assets/cutouts/spark_gold/jac-8401.jpg"
      },
      {
        "model": "JAC-8401A",
        "name": "Towel Rod 18\"",
        "price": 2230,
        "img": "/assets/cutouts/spark_gold/jac-8401a.jpg"
      },
      {
        "model": "JAC-8402",
        "name": "Towel Ring",
        "price": 2010
      },
      {
        "model": "JAC-8403",
        "name": "Robe Hook",
        "price": 1180
      },
      {
        "model": "JAC-8404",
        "name": "Soap Dish",
        "price": 1550
      },
      {
        "model": "JAC-8406",
        "name": "Toilet Paper Holder with Flap",
        "price": 3060,
        "img": "/assets/cutouts/spark_gold/jac-8406.jpg"
      },
      {
        "model": "JAC-8410",
        "name": "Liquid Soap Dispenser",
        "price": 2360,
        "img": "/assets/cutouts/spark_gold/jac-8410.jpg"
      },
      {
        "model": "JAC-8411",
        "name": "Tooth Brush Holder",
        "price": 1925,
        "img": "/assets/cutouts/spark_gold/jac-8411.jpg"
      },
      {
        "model": "JAC-8412",
        "name": "Double Soap Dish",
        "price": 2775
      },
      {
        "model": "JAC-8413",
        "name": "Tooth Brush Holder with Soap Dish",
        "price": 3150
      },
      {
        "model": "JAC-8414",
        "name": "Soap Dish with LSD",
        "price": 3475
      }
    ],
    "pages": [
      "/assets/pages_clean/p58.jpg",
      "/assets/pages_clean/p59.jpg"
    ]
  },
  {
    "id": "spark_rosegold",
    "name": "Spark Rose Gold",
    "category": "accessories",
    "line": "Bath Accessories",
    "image": "/assets/img/spark_rosegold.jpg",
    "blurb": "Blush metallic warmth across the full accessory range.",
    "featured": {
      "model": "JAC-8509",
      "name": "Towel Rack 24\"",
      "price": 6780
    },
    "items": [
      {
        "model": "JAC-8509",
        "name": "Towel Rack 24\"",
        "price": 6780,
        "img": "/assets/cutouts/spark_rosegold/jac-8509.jpg"
      },
      {
        "model": "JAC-8501",
        "name": "Towel Rod 24\"",
        "price": 2470
      },
      {
        "model": "JAC-8501A",
        "name": "Towel Rod 18\"",
        "price": 2230
      },
      {
        "model": "JAC-8502",
        "name": "Towel Ring",
        "price": 2010
      },
      {
        "model": "JAC-8503",
        "name": "Robe Hook",
        "price": 1180,
        "img": "/assets/cutouts/spark_rosegold/jac-8503.jpg"
      },
      {
        "model": "JAC-8504",
        "name": "Soap Dish",
        "price": 1550,
        "img": "/assets/cutouts/spark_rosegold/jac-8504.jpg"
      },
      {
        "model": "JAC-8506",
        "name": "Toilet Paper Holder with Flap",
        "price": 3060
      },
      {
        "model": "JAC-8510",
        "name": "Liquid Soap Dispenser",
        "price": 2360,
        "img": "/assets/cutouts/spark_rosegold/jac-8510.jpg"
      },
      {
        "model": "JAC-8511",
        "name": "Tooth Brush Holder",
        "price": 1925,
        "img": "/assets/cutouts/spark_rosegold/jac-8511.jpg"
      },
      {
        "model": "JAC-8512",
        "name": "Double Soap Dish",
        "price": 2775,
        "img": "/assets/cutouts/spark_rosegold/jac-8512.jpg"
      },
      {
        "model": "JAC-8513",
        "name": "Tooth Brush Holder with Soap Dish",
        "price": 3150,
        "img": "/assets/cutouts/spark_rosegold/jac-8513.jpg"
      },
      {
        "model": "JAC-8514",
        "name": "Soap Dish with LSD",
        "price": 3475,
        "img": "/assets/cutouts/spark_rosegold/jac-8514.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p60.jpg",
      "/assets/pages_clean/p61.jpg"
    ]
  },
  {
    "id": "spark_black",
    "name": "Spark Black",
    "category": "accessories",
    "line": "Bath Accessories",
    "image": "/assets/img/spark_black.jpg",
    "blurb": "Matte-black statements for monochrome interiors.",
    "featured": {
      "model": "JAC-8909",
      "name": "Towel Rack 24\"",
      "price": 6780
    },
    "items": [
      {
        "model": "JAC-8909",
        "name": "Towel Rack 24\"",
        "price": 6780,
        "img": "/assets/cutouts/spark_black/jac-8909.jpg"
      },
      {
        "model": "JAC-8901",
        "name": "Towel Rod 24\"",
        "price": 2470,
        "img": "/assets/cutouts/spark_black/jac-8901.jpg"
      },
      {
        "model": "JAC-8901A",
        "name": "Towel Rod 18\"",
        "price": 2230
      },
      {
        "model": "JAC-8905",
        "name": "Towel Ring",
        "price": 2010,
        "img": "/assets/cutouts/spark_black/jac-8905.jpg"
      },
      {
        "model": "JAC-8903",
        "name": "Robe Hook",
        "price": 1180,
        "img": "/assets/cutouts/spark_black/jac-8903.jpg"
      },
      {
        "model": "JAC-8904",
        "name": "Soap Dish",
        "price": 1550,
        "img": "/assets/cutouts/spark_black/jac-8904.jpg"
      },
      {
        "model": "JAC-8906",
        "name": "Toilet Paper Holder with Flap",
        "price": 3060,
        "img": "/assets/cutouts/spark_black/jac-8906.jpg"
      },
      {
        "model": "JAC-8910",
        "name": "Liquid Soap Dispenser",
        "price": 2360,
        "img": "/assets/cutouts/spark_black/jac-8910.jpg"
      },
      {
        "model": "JAC-8911",
        "name": "Tooth Brush Holder",
        "price": 1925,
        "img": "/assets/cutouts/spark_black/jac-8911.jpg"
      },
      {
        "model": "JAC-8912",
        "name": "Double Soap Dish",
        "price": 2775,
        "img": "/assets/cutouts/spark_black/jac-8912.jpg"
      },
      {
        "model": "JAC-8913",
        "name": "Tooth Brush Holder with Soap Dish",
        "price": 3150,
        "img": "/assets/cutouts/spark_black/jac-8913.jpg"
      },
      {
        "model": "JAC-8914",
        "name": "Soap Dish with LSD",
        "price": 3475,
        "img": "/assets/cutouts/spark_black/jac-8914.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p62.jpg",
      "/assets/pages_clean/p63.jpg"
    ]
  },
  {
    "id": "nexon",
    "name": "Nexon",
    "category": "accessories",
    "line": "Bath Accessories",
    "image": "/assets/img/nexon.jpg",
    "blurb": "Sharp-edged accessory architecture.",
    "featured": {
      "model": "JAC-9009",
      "name": "Towel Rack 24\"",
      "price": 3495
    },
    "items": [
      {
        "model": "JAC-9009",
        "name": "Towel Rack 24\"",
        "price": 3495,
        "img": "/assets/cutouts/nexon/jac-9009.jpg"
      },
      {
        "model": "JAC-9001",
        "name": "Towel Rod 24\"",
        "price": 1635,
        "img": "/assets/cutouts/nexon/jac-9001.jpg"
      },
      {
        "model": "JAC-9002",
        "name": "Towel Ring",
        "price": 1045,
        "img": "/assets/cutouts/nexon/jac-9002.jpg"
      },
      {
        "model": "JAC-9004",
        "name": "Soap Dish",
        "price": 940,
        "img": "/assets/cutouts/nexon/jac-9004.jpg"
      },
      {
        "model": "JAC-9006",
        "name": "Toilet Paper Holder with Flap",
        "price": 1530,
        "img": "/assets/cutouts/nexon/jac-9006.jpg"
      },
      {
        "model": "JAC-9010",
        "name": "Liquid Soap Dispenser",
        "price": 1485,
        "img": "/assets/cutouts/nexon/jac-9010.jpg"
      },
      {
        "model": "JAC-9011",
        "name": "Tooth Brush Holder",
        "price": 1115,
        "img": "/assets/cutouts/nexon/jac-9011.jpg"
      },
      {
        "model": "JAC-9012",
        "name": "Double Soap Dish",
        "price": 1640,
        "img": "/assets/cutouts/nexon/jac-9012.jpg"
      },
      {
        "model": "JAC-9013",
        "name": "Tooth Brush Holder with Soap Dish",
        "price": 1815,
        "img": "/assets/cutouts/nexon/jac-9013.jpg"
      },
      {
        "model": "JAC-9014",
        "name": "Soap Dish with LSD",
        "price": 2120,
        "img": "/assets/cutouts/nexon/jac-9014.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p64.jpg",
      "/assets/pages_clean/p65.jpg"
    ]
  },
  {
    "id": "fronx",
    "name": "Fronx",
    "category": "accessories",
    "line": "Bath Accessories",
    "image": "/assets/img/fronx.jpg",
    "blurb": "Compact utility, finished to jewellery standard.",
    "featured": {
      "model": "JAC-9309",
      "name": "Towel Rack 24\"",
      "price": 3930
    },
    "items": [
      {
        "model": "JAC-9309",
        "name": "Towel Rack 24\"",
        "price": 3930,
        "img": "/assets/cutouts/fronx/jac-9309.jpg"
      },
      {
        "model": "JAC-9301",
        "name": "Towel Rod 24\"",
        "price": 1635,
        "img": "/assets/cutouts/fronx/jac-9301.jpg"
      },
      {
        "model": "JAC-9302",
        "name": "Towel Ring",
        "price": 1045,
        "img": "/assets/cutouts/fronx/jac-9302.jpg"
      },
      {
        "model": "JAC-9303",
        "name": "Robe Hook",
        "price": 785,
        "img": "/assets/cutouts/fronx/jac-9303.jpg"
      },
      {
        "model": "JAC-9304",
        "name": "Soap Dish",
        "price": 940,
        "img": "/assets/cutouts/fronx/jac-9304.jpg"
      },
      {
        "model": "JAC-9306",
        "name": "Toilet Paper Holder with Flap",
        "price": 1530,
        "img": "/assets/cutouts/fronx/jac-9306.jpg"
      },
      {
        "model": "JAC-9310",
        "name": "Liquid Soap Dispenser",
        "price": 1155,
        "img": "/assets/cutouts/fronx/jac-9310.jpg"
      },
      {
        "model": "JAC-9311",
        "name": "Tooth Brush Holder",
        "price": 1155,
        "img": "/assets/cutouts/fronx/jac-9311.jpg"
      },
      {
        "model": "JAC-9312",
        "name": "Double Soap Dish",
        "price": 1640,
        "img": "/assets/cutouts/fronx/jac-9312.jpg"
      },
      {
        "model": "JAC-9313",
        "name": "Tooth Brush Holder with Soap Dish",
        "price": 1815,
        "img": "/assets/cutouts/fronx/jac-9313.jpg"
      },
      {
        "model": "JAC-9314",
        "name": "Soap Dish with LSD",
        "price": 2120,
        "img": "/assets/cutouts/fronx/jac-9314.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p66.jpg",
      "/assets/pages_clean/p67.jpg"
    ]
  },
  {
    "id": "vitara",
    "name": "Vitara",
    "category": "accessories",
    "line": "Bath Accessories",
    "image": "/assets/img/vitara.jpg",
    "blurb": "Rounded, welcoming forms for family baths.",
    "featured": {
      "model": "JAC-9409",
      "name": "Towel Rack 24\"",
      "price": 3505
    },
    "items": [
      {
        "model": "JAC-9409",
        "name": "Towel Rack 24\"",
        "price": 3505,
        "img": "/assets/cutouts/vitara/jac-9409.jpg"
      },
      {
        "model": "JAC-9401",
        "name": "Towel Rod 24\"",
        "price": 1565,
        "img": "/assets/cutouts/vitara/jac-9401.jpg"
      },
      {
        "model": "JAC-9402",
        "name": "Towel Ring",
        "price": 1005,
        "img": "/assets/cutouts/vitara/jac-9402.jpg"
      },
      {
        "model": "JAC-9403",
        "name": "Robe Hook",
        "price": 795,
        "img": "/assets/cutouts/vitara/jac-9403.jpg"
      },
      {
        "model": "JAC-9404",
        "name": "Soap Dish",
        "price": 1460,
        "img": "/assets/cutouts/vitara/jac-9404.jpg"
      },
      {
        "model": "JAC-9406",
        "name": "Toilet Paper Holder with Flap",
        "price": 1460,
        "img": "/assets/cutouts/vitara/jac-9406.jpg"
      },
      {
        "model": "JAC-9410",
        "name": "Liquid Soap Dispenser",
        "price": 1460,
        "img": "/assets/cutouts/vitara/jac-9410.jpg"
      },
      {
        "model": "JAC-9411",
        "name": "Tooth Brush Holder",
        "price": 1125
      },
      {
        "model": "JAC-9412",
        "name": "Double Soap Dish",
        "price": 1710,
        "img": "/assets/cutouts/vitara/jac-9412.jpg"
      },
      {
        "model": "JAC-9413",
        "name": "Tooth Brush Holder with Soap Dish",
        "price": 1795,
        "img": "/assets/cutouts/vitara/jac-9413.jpg"
      },
      {
        "model": "JAC-9414",
        "name": "Soap Dish with LSD",
        "price": 2000,
        "img": "/assets/cutouts/vitara/jac-9414.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p68.jpg",
      "/assets/pages_clean/p69.jpg"
    ]
  },
  {
    "id": "allied",
    "name": "Allied",
    "category": "accessories",
    "line": "Concealed Systems & Allieds",
    "image": "/assets/img/allied.jpg",
    "blurb": "Concealed bodies, diverters, rack bolts and traps \u2014 the invisible engineering behind the beauty.",
    "featured": {
      "model": "ALD-5584",
      "name": "Concealed Shower Mixer Body, 3-Way Diverter",
      "price": 10335
    },
    "items": [
      {
        "model": "ALD-5550",
        "name": "Concealed Stop Cock 15mm",
        "price": 1045,
        "img": "/assets/cutouts/allied/ald-5550.jpg"
      },
      {
        "model": "ALD-5551",
        "name": "Concealed Stop Cock 20mm",
        "price": 1120,
        "img": "/assets/cutouts/allied/ald-5551.jpg"
      },
      {
        "model": "ALD-5552",
        "name": "Concealed Stop Cock 15mm Hi-Flow",
        "price": 1485,
        "img": "/assets/cutouts/allied/ald-5552.jpg"
      },
      {
        "model": "ALD-5553",
        "name": "Concealed Stop Cock 20mm Hi-Flow",
        "price": 1680,
        "img": "/assets/cutouts/allied/ald-5553.jpg"
      },
      {
        "model": "ALD-5584",
        "name": "Concealed Body of Single Lever Shower Mixer with 3-Way Diverter",
        "price": 10335
      },
      {
        "model": "JCB-5554",
        "name": "Concealed Body for Wall Mounted Single Lever Basin Mixer",
        "price": 4030
      },
      {
        "model": "JDV-5580",
        "name": "Diverter Concealed Body 40mm Tipton",
        "price": 4970
      },
      {
        "model": "JDV-5581",
        "name": "Diverter Concealed Body 40mm Rotary",
        "price": 5090
      },
      {
        "model": "JDV-5582",
        "name": "Diverter Concealed Body Hi-Flow",
        "price": 6270,
        "img": "/assets/cutouts/allied/jdv-5582.jpg"
      },
      {
        "model": "JDV-5583",
        "name": "Diverter Concealed Body 3-Inlet Tipton",
        "price": 6370,
        "img": "/assets/cutouts/allied/jdv-5583.jpg"
      },
      {
        "model": "ALD-5587",
        "name": "3/4 Concealed Body for WM Pillar Cock",
        "price": 2240
      },
      {
        "model": "ALD-5558",
        "name": "1/2 Concealed Body for WM Pillar Cock",
        "price": 1785
      },
      {
        "model": "JBW-6080",
        "name": "Half Thread Waste Coupling 3\" Regular",
        "price": 425
      },
      {
        "model": "JBW-6081",
        "name": "Full Thread Waste Coupling 3\" Regular",
        "price": 425
      },
      {
        "model": "JBW-6082",
        "name": "Half Thread Waste Coupling 3\" Premium",
        "price": 495
      },
      {
        "model": "JBW-6083",
        "name": "Full Thread Waste Coupling 3\" Premium",
        "price": 495
      },
      {
        "model": "ALD-6085",
        "name": "Rack Bolt SS with ABS Cap",
        "price": 490
      },
      {
        "model": "ALD-6086",
        "name": "Rack Bolt SS with Brass CP Cap",
        "price": 635
      },
      {
        "model": "ALD-6087",
        "name": "Rack Bolt SS with MS Cap",
        "price": 565
      },
      {
        "model": "ALD-6088",
        "name": "SS Bolt with Cap",
        "price": 220
      },
      {
        "model": "ALD-6089",
        "name": "MS Bolt with Cap",
        "price": 140
      },
      {
        "model": "JBW-7004D",
        "name": "Grab Bar SS 202 9\"",
        "price": 385
      },
      {
        "model": "JBW-7004E",
        "name": "Grab Bar SS 202 12\"",
        "price": 775
      },
      {
        "model": "JBW-7004F",
        "name": "Grab Bar SS 202 15\"",
        "price": 545
      },
      {
        "model": "JBW-7004G",
        "name": "Grab Bar SS 202 18\"",
        "price": 620
      },
      {
        "model": "JBW-7004H",
        "name": "Grab Bar SS 202 24\"",
        "price": 690
      },
      {
        "model": "JBW-7004",
        "name": "Grab Bar SS 304",
        "price": 1345
      },
      {
        "model": "JBW-7001",
        "name": "Bottle Trap 32mm (German Type) with 7\"x5\" Pipe",
        "price": 1825
      },
      {
        "model": "JBW-7002",
        "name": "Bottle Trap 32mm (European Type) Cylindrical with 7\"x5\" Pipe",
        "price": 1740
      },
      {
        "model": "JBW-7010",
        "name": "Extension Nipple 25mm",
        "price": 120
      },
      {
        "model": "JBW-7011",
        "name": "Extension Nipple 40mm",
        "price": 175
      },
      {
        "model": "JBW-7012",
        "name": "Extension Nipple 50mm",
        "price": 230
      },
      {
        "model": "JBW-7013",
        "name": "Extension Nipple 63mm",
        "price": 285
      },
      {
        "model": "JBW-7014",
        "name": "Extension Nipple 75mm",
        "price": 345
      }
    ],
    "pages": [
      "/assets/pages_clean/p70.jpg",
      "/assets/pages_clean/p71.jpg"
    ]
  },
  {
    "id": "drainers",
    "name": "Drainers",
    "category": "accessories",
    "line": "Floor Drains & Channels",
    "image": "/assets/img/drainers.jpg",
    "blurb": "Square, round and channel drainers with cockroach traps in SS 304 & SS 202.",
    "featured": {
      "model": "JSD-8044",
      "name": "Channel Drainer with Trap SS 304 900mm",
      "price": 8865
    },
    "items": [
      {
        "model": "JBW-8001",
        "name": "Square Frame Grating with Hole 5\" SS 304",
        "price": 475
      },
      {
        "model": "JBW-8002",
        "name": "Square Frame Grating with Hole 6\" SS 304",
        "price": 805
      },
      {
        "model": "JBW-8003",
        "name": "Square Frame Grating w/o Hole 5\" SS 304",
        "price": 475
      },
      {
        "model": "JBW-8004",
        "name": "Square Frame Grating w/o Hole 6\" SS 304",
        "price": 805
      },
      {
        "model": "JBW-8005",
        "name": "Square Frame Cockroach Trap with Hole 5\" SS 304",
        "price": 805
      },
      {
        "model": "JBW-8006",
        "name": "Square Frame Cockroach Trap with Hole 6\" SS 304",
        "price": 1135
      },
      {
        "model": "JBW-8007",
        "name": "Square Frame Cockroach Trap w/o Hole 5\" SS 304",
        "price": 805
      },
      {
        "model": "JBW-8008",
        "name": "Square Frame Cockroach Trap w/o Hole SS 202",
        "price": 345
      },
      {
        "model": "JBW-8009",
        "name": "Square Frame Grating with Hole 5\" SS 304 (Heavy)",
        "price": 475
      },
      {
        "model": "JBW-8010",
        "name": "Square Frame Grating with Hole 6\" SS 304 (Heavy)",
        "price": 805
      },
      {
        "model": "JBW-8011",
        "name": "Square Frame Grating w/o Hole 5\" SS 304 (Heavy)",
        "price": 475
      },
      {
        "model": "JBW-8012",
        "name": "Square Frame Grating w/o Hole 6\" SS 304 (Heavy)",
        "price": 805
      },
      {
        "model": "JBW-8013",
        "name": "Square Frame Cockroach Trap with Hole 5\" SS 304 (Heavy)",
        "price": 805
      },
      {
        "model": "JBW-8014",
        "name": "Square Frame Cockroach Trap with Hole 6\" SS 304 (Heavy)",
        "price": 1135
      },
      {
        "model": "JBW-8015",
        "name": "Square Frame Cockroach Trap w/o Hole 5\" SS 304 (Heavy)",
        "price": 805
      },
      {
        "model": "JBW-8016",
        "name": "Square Frame Cockroach Trap w/o Hole 6\" SS 304 (Heavy)",
        "price": 1135
      },
      {
        "model": "JBW-8017",
        "name": "Square Frame Grating with Hole 5\" SS 304 (Slim)",
        "price": 395
      },
      {
        "model": "JBW-8018",
        "name": "Square Frame Grating with Hole 5\" SS 202",
        "price": 245
      },
      {
        "model": "JBW-8019",
        "name": "Square Frame Grating w/o Hole 5\" SS 304 (Slim)",
        "price": 395
      },
      {
        "model": "JBW-8020",
        "name": "Square Frame Grating w/o Hole 5\" SS 202",
        "price": 245
      },
      {
        "model": "JBW-8021",
        "name": "Square Frame Cockroach Trap Round Jali with Hole SS 304",
        "price": 670,
        "img": "/assets/cutouts/drainers/jbw-8021.jpg"
      },
      {
        "model": "JBW-8021A",
        "name": "Square Frame Cockroach Trap Round Jali with Hole SS 202",
        "price": 445
      },
      {
        "model": "JBW-8023",
        "name": "Square Frame Cockroach Trap Round Jali w/o Hole SS 304",
        "price": 670,
        "img": "/assets/cutouts/drainers/jbw-8023.jpg"
      },
      {
        "model": "JBW-8023A",
        "name": "Square Frame Cockroach Trap Round Jali w/o Hole SS 202",
        "price": 445,
        "img": "/assets/cutouts/drainers/jbw-8023a.jpg"
      },
      {
        "model": "JBW-8025",
        "name": "Round Frame Cockroach Trap Round Jali w/o Hole SS 304",
        "price": 655,
        "img": "/assets/cutouts/drainers/jbw-8025.jpg"
      },
      {
        "model": "JBW-8025A",
        "name": "Round Frame Cockroach Trap Round Jali w/o Hole SS 202",
        "price": 435,
        "img": "/assets/cutouts/drainers/jbw-8025a.jpg"
      },
      {
        "model": "JBW-8027",
        "name": "Round Frame Cockroach Trap Round Jali w/o Hole SS 304 (Heavy)",
        "price": 655,
        "img": "/assets/cutouts/drainers/jbw-8027.jpg"
      },
      {
        "model": "JBW-8027A",
        "name": "Round Frame Cockroach Trap Round Jali w/o Hole SS 202 (Heavy)",
        "price": 435,
        "img": "/assets/cutouts/drainers/jbw-8027a.jpg"
      },
      {
        "model": "JSD-8055",
        "name": "SS 304 Marble/Tile Drainer 5\"",
        "price": 1650
      },
      {
        "model": "JSD-8054",
        "name": "SS 304 Marble/Tile Drainer 6\"",
        "price": 2020
      },
      {
        "model": "JSD-8041",
        "name": "Channel Drainer with Trap SS 304 300mm",
        "price": 2975
      },
      {
        "model": "JSD-8042",
        "name": "Channel Drainer with Trap SS 304 450mm",
        "price": 4455
      },
      {
        "model": "JSD-8043",
        "name": "Channel Drainer with Trap SS 304 600mm",
        "price": 5930
      },
      {
        "model": "JSD-8044",
        "name": "Channel Drainer with Trap SS 304 900mm",
        "price": 8865
      },
      {
        "model": "JSD-8046A",
        "name": "Channel Drainer with Trap SS 304 1200mm",
        "price": 11840
      },
      {
        "model": "JSD-8047",
        "name": "Channel Drainer SS 304 300mm",
        "price": 2725,
        "img": "/assets/cutouts/drainers/jsd-8047.jpg"
      },
      {
        "model": "JSD-8048",
        "name": "Channel Drainer SS 304 450mm",
        "price": 4075,
        "img": "/assets/cutouts/drainers/jsd-8048.jpg"
      },
      {
        "model": "JSD-8050",
        "name": "Channel Drainer SS 304 750mm",
        "price": 5430,
        "img": "/assets/cutouts/drainers/jsd-8050.jpg"
      },
      {
        "model": "JSD-8051",
        "name": "Channel Drainer SS 304 900mm",
        "price": 8110,
        "img": "/assets/cutouts/drainers/jsd-8051.jpg"
      },
      {
        "model": "JSD-8053A",
        "name": "Channel Drainer SS 304 1200mm",
        "price": 10835,
        "img": "/assets/cutouts/drainers/jsd-8053a.jpg"
      },
      {
        "model": "JSD-8056",
        "name": "Vertical Grating SS 202 3\"",
        "price": 140,
        "img": "/assets/cutouts/drainers/jsd-8056.jpg"
      },
      {
        "model": "JSD-8057",
        "name": "Vertical Grating SS 202 4\"",
        "price": 180,
        "img": "/assets/cutouts/drainers/jsd-8057.jpg"
      },
      {
        "model": "JSD-8058",
        "name": "Vertical Grating SS 202 5\"",
        "price": 220,
        "img": "/assets/cutouts/drainers/jsd-8058.jpg"
      },
      {
        "model": "JSD-8059",
        "name": "Vertical Grating SS 202 6\"",
        "price": 280,
        "img": "/assets/cutouts/drainers/jsd-8059.jpg"
      }
    ],
    "pages": [
      "/assets/pages_clean/p72.jpg"
    ]
  }
];
